<template>
  <div class="page-wrapper">
    <div class="page-container">
      
      <!-- Breadcrumbs -->
      <div class="page-header">
        <div class="breadcrumb">
          <span class="crumb-link" @click="$router.push('/')">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            Asosiy
          </span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-link" @click="goBackToReja">Shaxsiy ish reja</span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-current">{{ teacherName || 'O\'qituvchi' }}</span>
        </div>
      </div>

      <!-- Info Card -->
      <div class="info-card">
        <div class="card-title-bar" style="display: flex; justify-content: space-between; align-items: center;">
          <h3>O'qituvchi haqida ma'lumot</h3>
          <button v-if="isAdmin && !isApprovedByOquvProrektor" class="btn-edit-teacher" @click="openEditTeacherModal" title="O'qituvchi ma'lumotlarini o'zgartirish">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
            O'zgartirish
          </button>
        </div>
        <div class="card-content">
          <table class="profile-table">
            <tbody>
              <tr>
                <td class="label-cell">F.I.Sh</td>
                <td class="value-cell">{{ teacherName }}</td>
              </tr>
              <tr>
                <td class="label-cell">Mutaxassisligi</td>
                <td class="value-cell">{{ specialty || 'Mutaxassislik ko\'rsatilmagan' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Fakultet</td>
                <td class="value-cell">{{ faculty || 'Fakultet ko\'rsatilmagan' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Dekan</td>
                <td class="value-cell">{{ dekanName }}</td>
              </tr>
              <tr>
                <td class="label-cell">Kafedra</td>
                <td class="value-cell">{{ kafedraName || 'Kafedra ko\'rsatilmagan' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Kafedra mudiri</td>
                <td class="value-cell">{{ mudirName }}</td>
              </tr>
              <tr>
                <td class="label-cell">Lavozimi</td>
                <td class="value-cell">{{ position || 'O\'qituvchi' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Ilmiy darajasi</td>
                <td class="value-cell">{{ degree || 'Darajasiz' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Akademik darajasi</td>
                <td class="value-cell">{{ rank || 'Unvonsiz' }}</td>
              </tr>
              <tr>
                <td class="label-cell">Stavkasi</td>
                <td class="value-cell">{{ stavka || '1,00 stavka' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Stepper / Approval Timeline -->
      <div class="stepper-card">
        <div class="stepper-track">
          <div v-for="(step, role) in approvalSteps" :key="role" class="stepper-node" :class="getStepClass(role)">
            <div class="node-icon">
              <!-- Checkmark Icon for approved -->
              <svg v-if="planStatus[role] === 'approved'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <!-- Clock Icon for waiting -->
              <svg v-else-if="planStatus[role] === 'waiting'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <!-- Cross Icon for rejected -->
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </div>
            <div class="node-label" :class="{ 'clickable-label': isStepClickable(role) }" @click="promptApprovalChange(role)">
              {{ step.label }}
              <div class="node-subtitle" v-if="planStatus[role] === 'approved'">
                {{ (role === 'yoshlar' || role === 'ilmiy') ? 'Kelishildi' : 'Tasdiqlangan' }}
              </div>
              <div class="node-subtitle" v-else-if="planStatus[role] === 'waiting'">Kutilmoqda</div>
              <div class="node-subtitle text-red-500" v-else>Rad etilgan</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Prorektor QR Tasdiq Card -->
      <div v-if="planStatus?.oquv === 'approved'" class="prorektor-qr-banner">
        <div class="qr-banner-left">
          <div class="qr-badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
            <span>RASMIY ELEKTRON TASDIQ</span>
          </div>
          <div class="qr-title-block">
            <div class="qr-main-title">"TASDIQLAYMAN" — O'quv ishlari bo'yicha prorektor</div>
            <div class="qr-signatory"><b>B.Primkulov</b> tomonidan tasdiqlangan</div>
          </div>
          <div class="qr-meta-row">
            <span class="qr-status-tag">"TASDIQLANDI"</span>
            <span class="qr-date-tag">{{ formatApprovalDate(planStatusDates?.oquv) }}</span>
            <span class="qr-doc-tag">Hujjat ID: REJA-{{ employeeId }}</span>
          </div>
        </div>
        <div class="qr-banner-right" @click="showQrModal = true" title="QR-kodni kattalashtirib ko'rish">
          <img v-if="prorektorQrCodeUrl" :src="prorektorQrCodeUrl" class="qr-preview-img" alt="QR-kod" />
          <span class="qr-zoom-label">QR-kodni ko'rish</span>
        </div>
      </div>

      <!-- Shaxsiy Ish Reja Detailed Table Card -->
      <div class="table-card">
        <div class="card-title-bar flex justify-between items-center">
          <h3>Shaxsiy ish reja</h3>
          <div class="flex gap-2">
            <button class="export-btn" @click="exportToExcel">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              Excelga yuklash
            </button>
            <button class="export-btn-word" @click="exportToWord">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              Wordda yuklash
            </button>
            <button class="export-btn-pdf" @click="exportToPdf">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              PDF yuklash
            </button>
          </div>
        </div>
        
        <div class="table-container" ref="rejaTable">
          <table class="reja-table">
            <thead>
              <!-- Top Grouped Header -->
              <tr>
                <th rowspan="2" class="w-10">#</th>
                <th rowspan="2" class="text-left">Fan nomi</th>
                <th rowspan="2" class="text-left">Ta'lim yo'nalishi</th>
                <th rowspan="2" class="text-center" style="min-width:90px">Guruh</th>
                <th rowspan="2" class="text-center" style="min-width:60px">Kurs</th>
                <th :colspan="activeAuditoryFields.length + 1" class="th-group th-audit">Auditoriya mashg'uloti</th>
                <th :colspan="activeOutAuditoryFields.length + 1" class="th-group th-tashqari">Auditoriyadan tashqari mashg'ulotlar</th>
                <th rowspan="2" class="w-20 font-bold">Jami</th>
                <th v-if="isAdmin && !isApprovedByOquvProrektor" rowspan="2" class="w-16 text-center font-bold text-red-600">Amal</th>
              </tr>
              <!-- Sub Headers -->
              <tr>
                <th v-for="f in activeAuditoryFields" :key="'h_aud_' + f.key" class="th-audit-sub">{{ f.label }}</th>
                <th class="th-audit-sub font-bold">Jami auditoriya</th>
                
                <th v-for="f in activeOutAuditoryFields" :key="'h_out_' + f.key" class="th-tashqari-sub">{{ f.label }}</th>
                <th class="th-tashqari-sub font-bold">Jami auditoriya tashqi</th>
              </tr>
            </thead>
            <tbody>
              
              <!-- KUZGI SEMESTER SECTION -->
              <tr class="semester-divider-row">
                <td :colspan="totalColumns" class="semester-header">Kuzgi</td>
              </tr>
              <tr v-if="kuzgiItems.length === 0">
                <td :colspan="totalColumns" class="text-center py-6 text-gray-400 bg-gray-50">Kuzgi semestrda yuklama mavjud emas</td>
              </tr>
              <tr v-for="(item, idx) in kuzgiItems" :key="'kuz_' + idx">
                <td class="text-center text-gray-500">{{ idx + 1 }}</td>
                <td class="font-medium text-gray-800">{{ item.subjectName }}</td>
                <td class="text-gray-600">{{ item.specialtyName }}</td>
                <td class="text-center text-gray-700" style="font-size:12px">{{ getDisplayGuruh(item) }}</td>
                <td class="text-center text-gray-700">{{ getKurs(item) }}</td>
                <!-- Auditory -->
                <td v-for="f in activeAuditoryFields" :key="'cell_aud_' + f.key" class="text-center">
                  {{ formatVal(item[f.key]) }}
                </td>
                <td class="text-center font-semibold bg-amber-50/30">{{ formatVal(getJamiIchki(item)) }}</td>
                <!-- Out of auditory -->
                <td v-for="f in activeOutAuditoryFields" :key="'cell_out_' + f.key" class="text-center">
                  {{ formatVal(item[f.key]) }}
                </td>
                <td class="text-center font-semibold bg-blue-50/30">{{ formatVal(getJamiTashqi(item)) }}</td>
                <!-- Total -->
                <td class="text-center font-bold text-gray-900 bg-gray-50/50">{{ formatVal(getJamiTotal(item)) }}</td>
                <td v-if="isAdmin && !isApprovedByOquvProrektor" class="text-center bg-gray-50/50">
                  <button class="btn-delete-item" @click.stop="confirmDeleteSubjectItem(item)" title="Fanni bazadan to'liq o'chirish">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  </button>
                </td>
              </tr>
              <!-- Kuzgi Jami Row -->
              <tr class="totals-row bg-indigo-50/20" v-if="kuzgiItems.length > 0">
                <td colspan="5" class="text-right font-bold pr-4 text-indigo-900">Kuzgi jami:</td>
                <td v-for="f in activeAuditoryFields" :key="'kuz_tot_' + f.key" class="text-center font-bold">
                  {{ formatVal(kuzgiTotals[f.key]) }}
                </td>
                <td class="text-center font-bold bg-amber-50">{{ formatVal(kuzgiTotals.jamiIchki) }}</td>
                <td v-for="f in activeOutAuditoryFields" :key="'kuz_tot_out_' + f.key" class="text-center font-bold">
                  {{ formatVal(kuzgiTotals[f.key]) }}
                </td>
                <td class="text-center font-bold bg-blue-50">{{ formatVal(kuzgiTotals.jamiTashqi) }}</td>
                <td class="text-center font-extrabold text-indigo-950 bg-gray-100">{{ formatVal(kuzgiTotals.jami) }}</td>
                <td v-if="isAdmin && !isApprovedByOquvProrektor" class="bg-gray-100"></td>
              </tr>

              <!-- BAHORGI SEMESTER SECTION -->
              <tr class="semester-divider-row">
                <td :colspan="totalColumns" class="semester-header">Bahorgi</td>
              </tr>
              <tr v-if="bahorgiItems.length === 0">
                <td :colspan="totalColumns" class="text-center py-6 text-gray-400 bg-gray-50">Bahorgi semestrda yuklama mavjud emas</td>
              </tr>
              <tr v-for="(item, idx) in bahorgiItems" :key="'bah_' + idx">
                <td class="text-center text-gray-500">{{ idx + 1 }}</td>
                <td class="font-medium text-gray-800">{{ item.subjectName }}</td>
                <td class="text-gray-600">{{ item.specialtyName }}</td>
                <td class="text-center text-gray-700" style="font-size:12px">{{ getDisplayGuruh(item) }}</td>
                <td class="text-center text-gray-700">{{ getKurs(item) }}</td>
                <!-- Auditory -->
                <td v-for="f in activeAuditoryFields" :key="'cell_bah_aud_' + f.key" class="text-center">
                  {{ formatVal(item[f.key]) }}
                </td>
                <td class="text-center font-semibold bg-amber-50/30">{{ formatVal(getJamiIchki(item)) }}</td>
                <!-- Out of auditory -->
                <td v-for="f in activeOutAuditoryFields" :key="'cell_bah_out_' + f.key" class="text-center">
                  {{ formatVal(item[f.key]) }}
                </td>
                <td class="text-center font-semibold bg-blue-50/30">{{ formatVal(getJamiTashqi(item)) }}</td>
                <!-- Total -->
                <td class="text-center font-bold text-gray-900 bg-gray-50/50">{{ formatVal(getJamiTotal(item)) }}</td>
                <td v-if="isAdmin && !isApprovedByOquvProrektor" class="text-center bg-gray-50/50">
                  <button class="btn-delete-item" @click.stop="confirmDeleteSubjectItem(item)" title="Fanni bazadan to'liq o'chirish">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  </button>
                </td>
              </tr>
              <!-- Bahorgi Jami Row -->
              <tr class="totals-row bg-indigo-50/20" v-if="bahorgiItems.length > 0">
                <td colspan="5" class="text-right font-bold pr-4 text-indigo-900">Bahorgi jami:</td>
                <td v-for="f in activeAuditoryFields" :key="'bah_tot_' + f.key" class="text-center font-bold">
                  {{ formatVal(bahorgiTotals[f.key]) }}
                </td>
                <td class="text-center font-bold bg-amber-50">{{ formatVal(bahorgiTotals.jamiIchki) }}</td>
                <td v-for="f in activeOutAuditoryFields" :key="'bah_tot_out_' + f.key" class="text-center font-bold">
                  {{ formatVal(bahorgiTotals[f.key]) }}
                </td>
                <td class="text-center font-bold bg-blue-50">{{ formatVal(bahorgiTotals.jamiTashqi) }}</td>
                <td class="text-center font-extrabold text-indigo-950 bg-gray-100">{{ formatVal(bahorgiTotals.jami) }}</td>
                <td v-if="isAdmin && !isApprovedByOquvProrektor" class="bg-gray-100"></td>
              </tr>

              <!-- GENERAL TOTAL ROW -->
              <tr class="grand-totals-row bg-indigo-100/40">
                <td colspan="5" class="text-right font-extrabold pr-4 text-indigo-950">Umumiy jami:</td>
                <td v-for="f in activeAuditoryFields" :key="'grand_tot_' + f.key" class="text-center font-extrabold">
                  {{ formatVal(grandTotals[f.key]) }}
                </td>
                <td class="text-center font-extrabold bg-amber-100/60">{{ formatVal(grandTotals.jamiIchki) }}</td>
                <td v-for="f in activeOutAuditoryFields" :key="'grand_tot_out_' + f.key" class="text-center font-extrabold">
                  {{ formatVal(grandTotals[f.key]) }}
                </td>
                <td class="text-center font-extrabold bg-blue-100/60">{{ formatVal(grandTotals.jamiTashqi) }}</td>
                <td class="text-center font-black text-indigo-950 bg-gray-200 text-base">{{ formatVal(grandTotals.jami) }}</td>
                <td v-if="isAdmin && !isApprovedByOquvProrektor" class="bg-gray-200"></td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>

      <!-- II. O'QUV-USLUBIY ISHLARI -->
      <div class="table-card">
        <div class="card-title-bar">
          <h3>II. O'quv-uslubiy ishlari</h3>
        </div>
        <div class="table-scroll">
          <table class="reja-table">
            <thead>
              <tr>
                <th style="width:50px">№</th>
                <th>Ish turlari</th>
                <th style="width:180px">Bajarish muddati</th>
                <th>Ish turlarini amalga oshirish mexanizmi</th>
                <th style="width:160px">To'plagan reyting bali</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in oquvUslubiyRows" :key="idx">
                <td class="text-center">{{ idx + 1 }}</td>
                <td><textarea class="cell-input" v-model="row.ishTurlari" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.muddati" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.mexanizm" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><input class="cell-input text-center font-semibold" :class="{ 'rating-active': canEditOquvUslubiyReyting && !isApprovedByOquvProrektor }" v-model="row.reyting" type="text" :readonly="!canEditOquvUslubiyReyting || isApprovedByOquvProrektor" placeholder="Ball kiriting..." /></td>
              </tr>
              <tr v-if="oquvUslubiyRows.length === 0">
                <td colspan="5" class="text-center text-gray-400 py-4">Ma'lumot yo'q</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="(canEditManual || isOquvProrektor) && !isApprovedByOquvProrektor" class="manual-actions">
          <button class="btn-add" @click="addRow('oquvUslubiy')">&#xFF0B; Yangi qator qo'shish</button>
          <button class="btn-remove" @click="removeLastRow('oquvUslubiy')">&#x1F5D1; Oxirgi qatorni o'chirish</button>
        </div>
        <div v-if="!isApprovedByOquvProrektor" class="manual-save-bar">
          <button class="btn-save" @click="saveManualSections" :disabled="savingManual">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
            {{ savingManual ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>

      <!-- III. ILMIY-TADQIQOT ISHLARI -->
      <div class="table-card">
        <div class="card-title-bar">
          <h3>III. Ilmiy-tadqiqot ishlari</h3>
        </div>
        <div class="table-scroll">
          <table class="reja-table">
            <thead>
              <tr>
                <th style="width:50px">№</th>
                <th>Ish turlari</th>
                <th style="width:180px">Bajarish muddati</th>
                <th>Ish turlarini amalga oshirish mexanizmi</th>
                <th style="width:160px">To'plagan reyting bali</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in ilmiyTadqiqotRows" :key="idx">
                <td class="text-center">{{ idx + 1 }}</td>
                <td><textarea class="cell-input" v-model="row.ishTurlari" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.muddati" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.mexanizm" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><input class="cell-input text-center font-semibold" :class="{ 'rating-active': canEditIlmiyTadqiqotReyting && !isApprovedByOquvProrektor }" v-model="row.reyting" type="text" :readonly="!canEditIlmiyTadqiqotReyting || isApprovedByOquvProrektor" placeholder="Ball kiriting..." /></td>
              </tr>
              <tr v-if="ilmiyTadqiqotRows.length === 0">
                <td colspan="5" class="text-center text-gray-400 py-4">Ma'lumot yo'q</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="(canEditManual || isIlmiyProrektor) && !isApprovedByOquvProrektor" class="manual-actions">
          <button class="btn-add" @click="addRow('ilmiyTadqiqot')">&#xFF0B; Yangi qator qo'shish</button>
          <button class="btn-remove" @click="removeLastRow('ilmiyTadqiqot')">&#x1F5D1; Oxirgi qatorni o'chirish</button>
        </div>
        <div v-if="!isApprovedByOquvProrektor" class="manual-save-bar">
          <button class="btn-save" @click="saveManualSections" :disabled="savingManual">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
            {{ savingManual ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>

      <!-- IV. USTOZ-SHOGIRD ISHLARI -->
      <div class="table-card">
        <div class="card-title-bar">
          <h3>IV. "Ustoz-shogird" ishlari</h3>
        </div>
        <div class="table-scroll">
          <table class="reja-table">
            <thead>
              <tr>
                <th style="width:50px">№</th>
                <th>Ish turlari</th>
                <th style="width:180px">Bajarish muddati</th>
                <th>Ish turlarini amalga oshirish mexanizmi</th>
                <th style="width:160px">To'plagan reyting bali</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in ustozShogirdRows" :key="idx">
                <td class="text-center">{{ idx + 1 }}</td>
                <td><textarea class="cell-input" v-model="row.ishTurlari" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.muddati" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><textarea class="cell-input" v-model="row.mexanizm" rows="3" :readonly="!canEditManual || isApprovedByOquvProrektor"></textarea></td>
                <td><input class="cell-input text-center font-semibold" :class="{ 'rating-active': canEditUstozShogirdReyting && !isApprovedByOquvProrektor }" v-model="row.reyting" type="text" :readonly="!canEditUstozShogirdReyting || isApprovedByOquvProrektor" placeholder="Ball kiriting..." /></td>
              </tr>
              <tr v-if="ustozShogirdRows.length === 0">
                <td colspan="5" class="text-center text-gray-400 py-4">Ma'lumot yo'q</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="(canEditManual || isYoshlarProrektor) && !isApprovedByOquvProrektor" class="manual-actions">
          <button class="btn-add" @click="addRow('ustozShogird')">&#xFF0B; Yangi qator qo'shish</button>
          <button class="btn-remove" @click="removeLastRow('ustozShogird')">&#x1F5D1; Oxirgi qatorni o'chirish</button>
        </div>
        <div v-if="!isApprovedByOquvProrektor" class="manual-save-bar">
          <button class="btn-save" @click="saveManualSections" :disabled="savingManual">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
            {{ savingManual ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>

    </div>

    <!-- Status Approval Switch Modal -->
    <div class="modal-overlay" v-if="showApprovalModal">
      <div class="approval-modal">
        <div class="modal-header">
          <h4>Tasdiqlash holatini o'zgartirish</h4>
          <button class="close-btn" @click="showApprovalModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <p class="text-sm text-gray-600 mb-4">
            Ushbu xodimning shaxsiy ish rejasini <strong>{{ approvalSteps[selectedRoleForChange]?.label }}</strong> sifatida holatini o'zgartiring:
          </p>
          <div class="status-options">
            <button class="status-opt-btn approved" @click="updateStepStatus('approved')">
              {{ (selectedRoleForChange === 'yoshlar' || selectedRoleForChange === 'ilmiy') ? 'Kelishish' : 'Tasdiqlash' }}
            </button>
            <button class="status-opt-btn waiting" @click="updateStepStatus('waiting')">
              Kutilmoqda rejimiga o'tkazish
            </button>
            <button class="status-opt-btn rejected" @click="updateStepStatus('rejected')">
              Rad etish
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Beautiful Error/Warning Modal -->
    <div class="modal-overlay" v-if="showWarningModal">
      <div class="approval-modal warning-modal">
        <div class="modal-header" style="background-color: #fffbeb; border-bottom: 1px solid #fde68a;">
          <h4 class="text-amber-800 flex items-center gap-2" style="color: #92400e; font-weight: 600; display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            {{ warningModalTitle }}
          </h4>
          <button class="close-btn" @click="showWarningModal = false">&times;</button>
        </div>
        <div class="modal-body text-center" style="padding: 24px; text-align: center;">
          <p class="text-base text-gray-700 font-medium" style="color: #374151; font-size: 15px; font-weight: 500; line-height: 1.5; margin-bottom: 24px;">
            {{ warningModalMessage }}
          </p>
          <button @click="showWarningModal = false" style="background-color: #d97706; color: white; border: none; padding: 10px 24px; border-radius: 6px; font-weight: 600; cursor: pointer; transition: background-color 0.15s;" onmouseover="this.style.backgroundColor='#b45309'" onmouseout="this.style.backgroundColor='#d97706'">
            Tushunarli
          </button>
        </div>
      </div>
    </div>

    <!-- Permanent Delete Modal for Super Admin -->
    <div class="modal-overlay" v-if="deleteConfirmSubjectRow" style="z-index:9999;">
      <div class="approval-modal delete-modal" style="max-width: 480px;">
        <div class="modal-header" style="background:#fef2f2; border-bottom:1px solid #fecaca;">
          <h4 style="color:#dc2626; font-weight:700; display:flex; align-items:center; gap:8px; margin:0; font-size:16px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            Fanni bazadan to'liq o'chirish
          </h4>
          <button class="close-btn" @click="deleteConfirmSubjectRow = null">&times;</button>
        </div>
        <div class="modal-body" style="padding:20px;">
          <p style="font-size:14px; color:#374151; margin-bottom:16px; line-height:1.5;">
            Ushbu fanni ma'lumotlar bazasidan <strong>to'liq va qayta tiklanmas</strong> qilib o'chirib tashlamoqchimisiz?
          </p>
          <div style="background:#f9fafb; border:1px solid #e5e7eb; border-radius:8px; padding:12px; font-size:13px; margin-bottom:20px;">
            <div><strong>Fan nomi:</strong> {{ deleteConfirmSubjectRow.subjectName }}</div>
            <div style="margin-top:4px;" v-if="deleteConfirmSubjectRow.guruhNomi"><strong>Guruh:</strong> {{ deleteConfirmSubjectRow.guruhNomi }}</div>
            <div style="margin-top:4px;" v-if="deleteConfirmSubjectRow.semestrTuri"><strong>Semestr:</strong> {{ deleteConfirmSubjectRow.semestrTuri }}</div>
          </div>
          <div style="display:flex; gap:10px;">
            <button class="btn-clear" @click="deleteConfirmSubjectRow = null" style="flex:1;">Bekor qilish</button>
            <button 
              @click="doDeleteSubjectItem" 
              :disabled="isDeletingItem" 
              style="flex:1; background:#dc2626; color:#fff; border:none; padding:10px 16px; border-radius:6px; font-weight:700; cursor:pointer;"
            >
              {{ isDeletingItem ? "O'chirilmoqda..." : "To'liq o'chirish (Bazadan)" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Teacher Info Modal (Admin Only) -->
    <div class="modal-overlay" v-if="showEditTeacherModal" style="z-index: 9999;">
      <div class="approval-modal edit-teacher-modal">
        <div class="modal-header" style="background: #f8fafc; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; padding: 16px 20px;">
          <h4 style="margin: 0; font-size: 16px; font-weight: 700; color: #1e293b; display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
            O'qituvchi ma'lumotlarini o'zgartirish
          </h4>
          <button class="close-btn" @click="showEditTeacherModal = false">&times;</button>
        </div>
        <div class="modal-body" style="padding: 20px; max-height: 80vh; overflow-y: auto;">
          <form @submit.prevent="saveTeacherInfo" style="display: flex; flex-direction: column; gap: 14px;">
            <div class="form-group">
              <label>F.I.Sh</label>
              <input v-model="editTeacherForm.employeeName" type="text" class="form-input-text" required placeholder="Familiya Ism Sharif" />
            </div>

            <div class="form-group">
              <label>Mutaxassisligi</label>
              <input v-model="editTeacherForm.specialty" type="text" class="form-input-text" placeholder="Mutaxassisligi" />
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div class="form-group">
                <label>Fakultet</label>
                <input v-model="editTeacherForm.faculty" type="text" class="form-input-text" placeholder="Fakultet nomi" />
              </div>
              <div class="form-group">
                <label>Dekan</label>
                <input v-model="editTeacherForm.dekanName" type="text" class="form-input-text" placeholder="Dekan F.I.Sh" />
              </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div class="form-group">
                <label>Kafedra</label>
                <input v-model="editTeacherForm.kafedraName" type="text" class="form-input-text" placeholder="Kafedra nomi" />
              </div>
              <div class="form-group">
                <label>Kafedra mudiri</label>
                <input v-model="editTeacherForm.mudirName" type="text" class="form-input-text" placeholder="Kafedra mudiri F.I.Sh" />
              </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div class="form-group">
                <label>Ilmiy darajasi</label>
                <input v-model="editTeacherForm.degree" type="text" class="form-input-text" placeholder="Fan nomzodi, PhD, DSc..." />
              </div>
              <div class="form-group">
                <label>Akademik darajasi (Unvoni)</label>
                <input v-model="editTeacherForm.rank" type="text" class="form-input-text" placeholder="Dotsent, Professor..." />
              </div>
            </div>

            <div class="form-group">
              <label>Stavkasi</label>
              <div style="display: flex; gap: 8px;">
                <input v-model="editTeacherForm.stavka" type="text" class="form-input-text" placeholder="Masalan: 0,50 stavka yoki 1,00 stavka" style="flex: 1;" />
                <button type="button" class="btn-stavka-quick" @click="editTeacherForm.stavka = '0,50 stavka'">0.5</button>
                <button type="button" class="btn-stavka-quick" @click="editTeacherForm.stavka = '1,00 stavka'">1.0</button>
                <button type="button" class="btn-stavka-quick" @click="editTeacherForm.stavka = '0,25 stavka'">0.25</button>
                <button type="button" class="btn-stavka-quick" @click="editTeacherForm.stavka = '0,75 stavka'">0.75</button>
              </div>
              <small style="color: #64748b; font-size: 11px; margin-top: 4px; display: block;">
                O'zgartirilgan stavka va barcha ma'lumotlar bazada qat'iy saqlanadi va HEMIS sinxronizatsiyasida o'chib ketmaydi.
              </small>
            </div>

            <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 8px; border-top: 1px solid #e2e8f0; padding-top: 14px;">
              <button type="button" class="btn-clear" @click="showEditTeacherModal = false">Bekor qilish</button>
              <button type="submit" class="btn-save" :disabled="isSavingTeacherInfo" style="padding: 10px 24px;">
                {{ isSavingTeacherInfo ? 'Saqlanmoqda...' : 'Saqlash' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- PDF Generation Loading Overlay -->
    <div v-if="isExportingPdf" style="position: fixed; inset: 0; background: rgba(15, 23, 42, 0.85); backdrop-filter: blur(4px); z-index: 999999; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #ffffff;">
      <div style="width: 50px; height: 50px; border: 4px solid rgba(255,255,255,0.3); border-top-color: #38bdf8; border-radius: 50%; animation: pdfSpin 1s linear infinite; margin-bottom: 16px;"></div>
      <div style="font-size: 18px; font-weight: 700; margin-bottom: 6px; letter-spacing: -0.01em;">PDF tayyorlanmoqda...</div>
      <div style="font-size: 14px; color: #cbd5e1; font-weight: 500;">{{ pdfExportProgress }}</div>
    </div>

    <!-- Prorektor QR Modal -->
    <div v-if="showQrModal" class="modal-overlay" @click.self="showQrModal = false">
      <div class="modal-card qr-modal-card">
        <div class="modal-header">
          <h3>Elektron QR-tasdiq</h3>
          <button class="modal-close-btn" @click="showQrModal = false">✕</button>
        </div>
        <div class="modal-body text-center" style="padding: 24px; text-align: center;">
          <div style="font-weight: 800; font-size: 15pt; color: #1e293b; margin-bottom: 4px;">"TASDIQLAYMAN"</div>
          <div style="font-size: 11pt; color: #475569; font-weight: 600;">O'quv ishlari bo'yicha prorektor</div>
          <div style="font-weight: 700; font-size: 13pt; color: #0f172a; margin-top: 4px;">B.Primkulov</div>
          <div style="display: inline-block; font-weight: 800; font-size: 13pt; color: #15803d; background: #dcfce7; border: 1px solid #86efac; border-radius: 6px; padding: 4px 16px; margin: 12px 0;">"TASDIQLANDI"</div>
          <img v-if="prorektorQrCodeUrl" :src="prorektorQrCodeUrl" style="width: 190px; height: 190px; margin: 8px auto; display: block; border: 2px solid #e2e8f0; border-radius: 10px; padding: 8px; background: #ffffff;" alt="QR Kod" />
          <div style="font-size: 11pt; color: #334155; font-weight: 600; margin-top: 8px;">
            {{ formatApprovalDate(planStatusDates?.oquv) }}
          </div>
          <div style="font-size: 9pt; color: #64748b; margin-top: 4px;">
            Hujjat raqami: REJA-{{ employeeId }} | Termiz davlat muhandislik va agrotexnologiyalar universiteti
          </div>
        </div>
        <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 12px 20px; border-top: 1px solid #e2e8f0;">
          <button class="btn-clear" @click="showQrModal = false">Yopish</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import { getKafedraDecisionCoverHtml, getKafedraDecisionText, findKafedraProtocol, kafedraProtocols } from "../utils/kafedraHelper";
const API = process.env.VUE_APP_API_URL || "http://localhost:3300/api";

export default {
  name: "ShaxsiyIshRejaDetail",
  data() {
    return {
      employeeId: "",
      teacherName: "",
      kafedraName: "",
      departmentId: "",
      stavka: "",
      degree: "",
      rank: "",
      position: "",
      specialty: "",
      faculty: "",
      
      // Approval steps map
      approvalSteps: {
        teacher: { label: "O'qituvchi" },
        kafedra: { label: "Kafedra" },
        dekan: { label: "Dekan" },
        yoshlar: { label: "Yoshlar ishlari bo'yicha prorektor" },
        ilmiy: { label: "Ilmiy ishlari bo'yicha prorektor" },
        oquv: { label: "O'quv ishlari bo'yicha prorektor" }
      },

      // Status values (retrieved from backend)
      planStatus: {
        teacher: "approved",
        kafedra: "approved",
        dekan: "waiting",
        yoshlar: "waiting",
        ilmiy: "waiting",
        oquv: "waiting"
      },
      planStatusDates: {},
      prorektorQrCodeUrl: "",
      showQrModal: false,
      updatedAt: null,

      items: [],
      loading: false,

      // Modal
      showApprovalModal: false,
      selectedRoleForChange: "",

      // Decan and Mudir mock values
      dekanName: "",
      mudirName: "",

      // Role check
      loggedInUser: null,
      userRole: "",

      // Warning modal
      showWarningModal: false,
      warningModalTitle: "",
      warningModalMessage: "",

      // Manual sections data
      oquvUslubiyRows: [],
      ilmiyTadqiqotRows: [],
      ustozShogirdRows: [],
      savingManual: false,

      // Delete confirmation modal state
      deleteConfirmSubjectRow: null,
      isDeletingItem: false,

      // Edit Teacher Info Modal
      showEditTeacherModal: false,
      isSavingTeacherInfo: false,
      editTeacherForm: {
        employeeName: "",
        specialty: "",
        faculty: "",
        dekanName: "",
        kafedraName: "",
        mudirName: "",
        degree: "",
        rank: "",
        stavka: ""
      },

      // PDF export status
      isExportingPdf: false,
      pdfExportProgress: ""
    };
  },
  computed: {
    isAdmin() {
      const r = (this.userRole || '').trim().toLowerCase();
      return ['super admin', 'superadmin', 'admin', 'administartor'].includes(r);
    },
    kuzgiItems() {
      return this.items.filter(item => {
        const st = (item.semestrTuri || "").toLowerCase().trim();
        if (st.includes("kuz") || st === "1") return true;
        if (st.includes("bahor") || st === "2") return false;
        const code = Number(item.semesterCode || item.semester?.code);
        return !isNaN(code) && code > 0 && code % 2 === 1;
      });
    },
    bahorgiItems() {
      return this.items.filter(item => {
        const st = (item.semestrTuri || "").toLowerCase().trim();
        if (st.includes("bahor") || st === "2") return true;
        if (st.includes("kuz") || st === "1") return false;
        const code = Number(item.semesterCode || item.semester?.code);
        return !isNaN(code) && code > 0 && code % 2 === 0;
      });
    },
    kuzgiTotals() {
      return this.calculateTotals(this.kuzgiItems);
    },
    bahorgiTotals() {
      return this.calculateTotals(this.bahorgiItems);
    },
    grandTotals() {
      return this.calculateTotals(this.items);
    },
    activeAuditoryFields() {
      const fields = [
        { key: 'maruza', label: 'Ma\'ruza' },
        { key: 'amaliy', label: 'Amaliy mashg\'ulot' },
        { key: 'seminar', label: 'Seminar mashg\'ulot' },
        { key: 'laboratoriya', label: 'Laboratoriya mashg\'ulot' }
      ];
      return fields.filter(f => this.items.some(item => (item[f.key] || 0) > 0));
    },
    activeOutAuditoryFields() {
      const fields = [
        { key: 'kursIshi', label: 'Kurs ishiga rahbarlik' },
        { key: 'kursIshiHimoya', label: 'Kurs ishi himoyasi' },
        { key: 'oraliq', label: 'Oraliq nazorat' },
        { key: 'yakuniy', label: 'Yakuniy nazorat' },
        { key: 'boshqaTashqari', label: 'Auditoriyadan tashqari boshqa' }
      ];
      return fields.filter(f => this.items.some(item => (item[f.key] || 0) > 0));
    },
    isApprovedByOquvProrektor() {
      return Boolean(this.planStatus && this.planStatus.oquv === 'approved');
    },
    totalColumns() {
      return this.activeAuditoryFields.length + this.activeOutAuditoryFields.length + (this.isAdmin && !this.isApprovedByOquvProrektor ? 9 : 8);
    },
    isOwnerTeacher() {
      const r = (this.userRole || '').trim().toLowerCase().replace(/[`‘']/g, "'");
      const isTeacher = ["qituvchi", "o'qituvchi", 'teacher', 'katta o\'qituvchi', 'assistent', 'assistant', 'dotsent', 'docent', 'professor', 'stajyor', 'foydalanuvchi', 'user'].some(x => r.includes(x));
      if (!isTeacher) return false;

      const loggedInId = this.loggedInUser?.employee_id_number || 
                         this.loggedInUser?.employee_id || 
                         this.loggedInUser?.id ||
                         this.loggedInUser?.hemis_id;
      const loggedInMetaId = this.loggedInUser?.meta_id;
      const loggedInName = (this.loggedInUser?.name || this.loggedInUser?.full_name || '').trim().toLowerCase();
      const curName = (this.teacherName || this.$route.query.name || '').trim().toLowerCase();

      // Check ID match
      if (loggedInId && String(loggedInId) === String(this.employeeId)) return true;
      if (loggedInMetaId && String(loggedInMetaId) === String(this.employeeId)) return true;
      if (this.loggedInUser?.id && String(this.loggedInUser.id) === String(this.employeeId)) return true;

      // Check Name match
      if (loggedInName && curName) {
        if (loggedInName === curName || loggedInName.includes(curName) || curName.includes(loggedInName)) return true;
        const p1 = loggedInName.split(/\s+/).filter(Boolean);
        const p2 = curName.split(/\s+/).filter(Boolean);
        if (p1.length >= 2 && p2.length >= 2) {
          const common = p1.filter(w => p2.includes(w));
          if (common.length >= 2) return true;
        }
      }

      if (!loggedInId) return true;
      return false;
    },
    canEditManual() {
      if (this.isApprovedByOquvProrektor) return false;
      const r = (this.userRole || '').trim().toLowerCase();
      const isAdmin = ['super admin', 'superadmin', 'admin', 'administartor'].includes(r);
      // Only teacher (own page) and admin can edit; kafedra mudiri and others are readonly
      if (isAdmin) return true;
      return this.isOwnerTeacher;
    },
    isYoshlarProrektor() {
      const r = (this.userRole || '').trim().toLowerCase().replace(/[`‘']/g, "'");
      return r.includes("prorektor") && r.includes("yoshlar");
    },
    isIlmiyProrektor() {
      const r = (this.userRole || '').trim().toLowerCase().replace(/[`‘']/g, "'");
      return r.includes("prorektor") && r.includes("ilmiy");
    },
    isOquvProrektor() {
      const r = (this.userRole || '').trim().toLowerCase().replace(/[`‘']/g, "'");
      return r.includes("prorektor") && (r.includes("o'quv") || r.includes("oquv"));
    },
    canEditUstozShogirdReyting() {
      if (this.isApprovedByOquvProrektor) return false;
      return this.canEditManual || this.isYoshlarProrektor;
    },
    canEditIlmiyTadqiqotReyting() {
      if (this.isApprovedByOquvProrektor) return false;
      return this.canEditManual || this.isIlmiyProrektor;
    },
    canEditOquvUslubiyReyting() {
      if (this.isApprovedByOquvProrektor) return false;
      return this.canEditManual || this.isOquvProrektor;
    },
    hasUstozShogirdBall() {
      if (!this.ustozShogirdRows || this.ustozShogirdRows.length === 0) return false;
      return this.ustozShogirdRows.some(r => {
        if (!r || r.reyting === undefined || r.reyting === null) return false;
        const val = String(r.reyting).trim();
        if (!val) return false;
        const num = parseFloat(val.replace(',', '.'));
        return !isNaN(num) && num > 0;
      });
    },
    hasIlmiyTadqiqotBall() {
      if (!this.ilmiyTadqiqotRows || this.ilmiyTadqiqotRows.length === 0) return false;
      return this.ilmiyTadqiqotRows.some(r => {
        if (!r || r.reyting === undefined || r.reyting === null) return false;
        const val = String(r.reyting).trim();
        if (!val) return false;
        const num = parseFloat(val.replace(',', '.'));
        return !isNaN(num) && num > 0;
      });
    },
    hasOquvUslubiyBall() {
      if (!this.oquvUslubiyRows || this.oquvUslubiyRows.length === 0) return false;
      return this.oquvUslubiyRows.some(r => {
        if (!r || r.reyting === undefined || r.reyting === null) return false;
        const val = String(r.reyting).trim();
        if (!val) return false;
        const num = parseFloat(val.replace(',', '.'));
        return !isNaN(num) && num > 0;
      });
    }
  },
  mounted() {
    this.employeeId = this.$route.params.employeeId;
    this.teacherName = this.$route.query.name || "Xodim";
    const isShortId = this.employeeId && String(this.employeeId).length < 7;
    this.stavka = this.$route.query.stavka || (isShortId ? "0,50 stavka" : "1,00 stavka");
    if (isShortId && (this.stavka.includes("1,00") || this.stavka.includes("1.00"))) {
      this.stavka = "0,50 stavka";
    }
    this.degree = this.$route.query.degree || "Darajasiz";
    this.rank = this.$route.query.rank || "Katta o'qituvchi";
    this.specialty = this.$route.query.specialty || "";
    if (this.specialty && /^\d{2}\.\d{2}/.test(this.specialty.trim())) {
      this.specialty = this.kafedraName || "";
    }
    this.faculty = this.$route.query.faculty || "";

    this.departmentId = this.$route.query.departmentId || "";
    if (this.departmentId) {
      sessionStorage.setItem("shaxsiy_reja_selected_department", String(this.departmentId));
      this.fetchDepartmentInfo(this.departmentId);
      this.fetchMudirName(this.departmentId);
    }

    const userData = localStorage.getItem("user");
    if (userData && userData !== "undefined") {
      try {
        const parsed = JSON.parse(userData);
        this.loggedInUser = parsed;
        this.userRole = parsed.role || "";
      } catch (e) {
        console.error("Error reading user data", e);
      }
    }

    // Guard: Teachers can only view their own plan
    const roleLower = (this.userRole || '').trim().toLowerCase().replace(/[`‘']/g, "'");
    const isTeacher = ["qituvchi", "o'qituvchi", 'teacher', 'katta o\'qituvchi', 'assistent', 'assistant', 'dotsent', 'docent', 'professor', 'stajyor', 'foydalanuvchi', 'user'].some(x => roleLower.includes(x));
    if (isTeacher) {
      const loggedInId = this.loggedInUser?.employee_id_number || 
                         this.loggedInUser?.employee_id || 
                         this.loggedInUser?.id ||
                         this.loggedInUser?.hemis_id;
      if (!this.isOwnerTeacher && loggedInId && String(this.employeeId).length >= 7) {
        this.employeeId = String(loggedInId);
        const prefix = this.$route.path.startsWith('/oktyabr') ? '/oktyabr' : '';
        this.$router.replace(`${prefix}/shaxsiy-ish-reja/${loggedInId}`);
      }
    }

    this.fetchData();
  },
  methods: {
    goBackToReja() {
      const deptId = this.$route.query.departmentId || sessionStorage.getItem("shaxsiy_reja_selected_department") || this.departmentId;
      const tab = this.$route.query.tab || sessionStorage.getItem("shaxsiy_reja_current_tab") || "waiting";
      const query = {};
      if (deptId) query.departmentId = deptId;
      if (tab) query.tab = tab;
      const basePath = this.$route.path.startsWith('/oktyabr') ? '/oktyabr/shaxsiy-ish-reja' : '/shaxsiy-ish-reja';
      this.$router.push({ path: basePath, query });
    },
    getDisplayGuruh(item) {
      if (!item) return '—';
      const gName = String(item.guruhNomi || "").trim();
      if (gName.includes(',')) return gName;
      if (item.curriculumName && item.curriculumName.trim() !== '') {
        return item.curriculumName.trim();
      }
      return gName || '—';
    },
    getKurs(item) {
      if (!item) return '—';
      if (item.kurs) return item.kurs;
      if (item.customKurs) return item.customKurs;

      const semCode = Number(item.semesterCode || item.semester?.code);
      if (semCode >= 11) {
        return Math.ceil((semCode - 10) / 2);
      }
      if (semCode >= 1 && semCode <= 10) {
        return Math.ceil(semCode / 2);
      }

      const guruh = item.guruhNomi || "";
      const yearMatch = guruh.match(/(\d{4})/);
      if (yearMatch) {
        const startYear = Number(yearMatch[1]);
        if (startYear >= 2020 && startYear <= 2030) {
          const calc = 2026 - startYear + 1;
          if (calc >= 1 && calc <= 7) return calc;
        }
      }

      const shortMatch = guruh.match(/(\d{2})[A-Z]/i);
      if (shortMatch) {
        const yr = Number(shortMatch[1]) + 2000;
        const calc = 2026 - yr + 1;
        if (calc >= 1 && calc <= 7) return calc;
      }

      return '—';
    },
    getDateStr(role, formatType = 'dot') {
      const isApproved = this.planStatus && this.planStatus[role] === 'approved';
      if (!isApproved) {
        if (formatType === 'uzbek') return '«___» _________ 2026 y.';
        return '____________________';
      }
      const dateRaw = (this.planStatusDates && this.planStatusDates[role]) 
        ? this.planStatusDates[role] 
        : (this.updatedAt || new Date());
      const d = new Date(dateRaw);
      if (isNaN(d.getTime())) {
        if (formatType === 'uzbek') return '« 03 » sentyabr 2026 y.';
        return '03.09.2026 y.';
      }
      const day = String(d.getDate()).padStart(2, '0');
      const monthNum = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      if (formatType === 'uzbek') {
        const months = ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avgust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'];
        return `« ${day} » ${months[d.getMonth()]} ${year} y.`;
      }
      return `${day}.${monthNum}.${year} y.`;
    },
    formatApprovalDate(d) {
      if (!d) return "";
      try {
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return "";
        const day = String(dt.getDate()).padStart(2, '0');
        const months = ["yanvar", "fevral", "mart", "aprel", "may", "iyun", "iyul", "avgust", "sentyabr", "oktyabr", "noyabr", "dekabr"];
        const month = months[dt.getMonth()];
        const year = dt.getFullYear();
        return `« ${day} » ${month} ${year} y.`;
      } catch (e) {
        return "";
      }
    },
    async generateProrektorQr() {
      if (this.planStatus?.oquv !== 'approved') {
        this.prorektorQrCodeUrl = "";
        return;
      }
      try {
        const empId = this.employeeId || this.$route.params.employeeId || "";
        const host = window.location.host;
        const protocol = window.location.protocol;
        const baseUrl = (host.includes("localhost") || host.includes("127.0.0.1"))
          ? "https://oquv.tdmau.uz"
          : `${protocol}//${host}`;
        const qrUrl = `${baseUrl}/verify/shaxsiy-reja/${empId}?oquvYili=2026-2027`;

        this.prorektorQrCodeUrl = await QRCode.toDataURL(qrUrl, {
          width: 160,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        });
      } catch (err) {
        console.error("QR Code generation error:", err);
      }
    },
    formatVal(val) {
      if (val === 0 || !val) return 0;
      const num = Number(val);
      return isNaN(num) ? val : Number(num.toFixed(1));
    },
    getJamiIchki(item) {
      const val = (item.maruza || 0) + (item.amaliy || 0) + (item.seminar || 0) + (item.laboratoriya || 0);
      return Number(val.toFixed(1));
    },
    getJamiTashqi(item) {
      const val = (item.kursIshi || 0) + (item.kursIshiHimoya || 0) + (item.oraliq || 0) + (item.yakuniy || 0) + (item.boshqaTashqari || 0);
      return Number(val.toFixed(1));
    },
    getJamiTotal(item) {
      const val = this.getJamiIchki(item) + this.getJamiTashqi(item);
      return Number(val.toFixed(1));
    },
    getStepClass(role) {
      const status = this.planStatus[role];
      if (status === "approved") return "node-approved";
      if (status === "rejected") return "node-rejected";
      return "node-waiting";
    },
    async fetchData() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        const oquvYili = this.$route.query.oquvYili || localStorage.getItem('selectedOquvYili') || '2026-2027';
        const res = await axios.get(`${API}/shaxsiy-reja/${this.employeeId}`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { 
            oquvYili,
            name: this.teacherName && this.teacherName !== "Xodim" ? this.teacherName : undefined,
            departmentId: this.departmentId || undefined,
            stavka: this.stavka && this.stavka !== "1,00 stavka" ? this.stavka : undefined
          }
        });
        if (res.data.success && res.data.data) {
          const doc = res.data.data;
          const isShortId = String(this.employeeId || '').length < 7;
          this.items = doc.items || [];
          if (doc.status) {
            this.planStatus = { ...this.planStatus, ...doc.status };
          }
          if (doc.statusDates) {
            this.planStatusDates = doc.statusDates;
          }
          if (doc.updatedAt) {
            this.updatedAt = doc.updatedAt;
          }

          if (doc.employeeName && !doc.employeeName.startsWith("O'qituvchi (")) {
            this.teacherName = doc.employeeName;
          }
          if (doc.kafedraName) this.kafedraName = doc.kafedraName;
          if (doc.faculty) this.faculty = doc.faculty;
          if (doc.dekanName || doc.deanName) this.dekanName = doc.dekanName || doc.deanName;
          if (doc.mudirName) this.mudirName = doc.mudirName;

          if (doc.teacherMeta) {
            if (!this.faculty || this.faculty === "Fakultet ko'rsatilmagan") {
              if (doc.teacherMeta.faculty) this.faculty = doc.teacherMeta.faculty;
            }
            if (!this.dekanName && (doc.teacherMeta.dekan || doc.teacherMeta.dekanName)) {
              this.dekanName = doc.teacherMeta.dekan || doc.teacherMeta.dekanName;
            }
            if (!this.mudirName && (doc.teacherMeta.kafedraMudiri || doc.teacherMeta.mudirName)) {
              this.mudirName = doc.teacherMeta.kafedraMudiri || doc.teacherMeta.mudirName;
            }
          }
          if (doc.specialty && !/^\d{2}\.\d{2}/.test(doc.specialty.trim())) {
            this.specialty = doc.specialty;
          } else {
            this.specialty = this.kafedraName || doc.kafedraName || "";
          }
          if (doc.degree && doc.degree !== "Darajasiz") this.degree = doc.degree;
          else if (doc.teacherMeta?.academicDegree && doc.teacherMeta.academicDegree !== "Darajasiz") this.degree = doc.teacherMeta.academicDegree;
          else if (doc.degree) this.degree = doc.degree;

          if (doc.rank && doc.rank !== "Unvonsiz") this.rank = doc.rank;
          else if (doc.teacherMeta?.academicRank && doc.teacherMeta.academicRank !== "Unvonsiz") this.rank = doc.teacherMeta.academicRank;
          else if (doc.rank) this.rank = doc.rank;

          if (doc.stavka) this.stavka = doc.stavka;
          else if (doc.teacherMeta?.stavka) this.stavka = doc.teacherMeta.stavka;
          if (isShortId && (this.stavka.includes("1,00") || this.stavka.includes("1.00"))) {
            this.stavka = "0,50 stavka";
          }

          if (doc.position) this.position = doc.position;
          else if (doc.teacherMeta?.position) this.position = doc.teacherMeta.position;

          if (!this.specialty && this.items && this.items.length > 0) {
            const itemWithSpec = this.items.find(i => i.specialtyName);
            if (itemWithSpec && !/^\d{2}\.\d{2}/.test(itemWithSpec.specialtyName.trim())) {
              this.specialty = itemWithSpec.specialtyName;
            }
          }
          if (!this.specialty && this.kafedraName) {
            this.specialty = this.kafedraName;
          }

          if (doc.departmentId) {
            this.departmentId = doc.departmentId;
            sessionStorage.setItem("shaxsiy_reja_selected_department", String(doc.departmentId));
            if (!this.mudirName) this.fetchMudirName(doc.departmentId);
            if (!this.dekanName || !this.faculty) this.fetchDepartmentInfo(doc.departmentId);
          }
          // Load manual sections if saved
          this.oquvUslubiyRows = doc.oquvUslubiy || [];
          this.ilmiyTadqiqotRows = doc.ilmiyTadqiqot || [];
          this.ustozShogirdRows = doc.ustozShogird || [];
          // Ensure at least 2 rows in each section
          if (this.oquvUslubiyRows.length === 0) this.oquvUslubiyRows = this.emptyRows(2);
          if (this.ilmiyTadqiqotRows.length === 0) this.ilmiyTadqiqotRows = this.emptyRows(2);
          if (this.ustozShogirdRows.length === 0) this.ustozShogirdRows = this.emptyRows(2);

          await this.generateProrektorQr();
        }
      } catch (err) {
        console.error("Error fetching detailed plan", err);
      } finally {
        this.loading = false;
      }
    },
    openEditTeacherModal() {
      if (this.isApprovedByOquvProrektor) {
        this.showWarning(
          "O'zgartirish taqiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani tasdiqlagan! O'qituvchi ma'lumotlarini o'zgartirib bo'lmaydi."
        );
        return;
      }
      this.editTeacherForm = {
        employeeName: this.teacherName || "",
        specialty: (this.specialty && this.specialty !== "Mutaxassislik ko'rsatilmagan") ? this.specialty : "",
        faculty: (this.faculty && this.faculty !== "Fakultet ko'rsatilmagan") ? this.faculty : "",
        dekanName: this.dekanName || "",
        kafedraName: (this.kafedraName && this.kafedraName !== "Kafedra ko'rsatilmagan") ? this.kafedraName : "",
        mudirName: this.mudirName || "",
        degree: (this.degree && this.degree !== "Darajasiz") ? this.degree : "",
        rank: (this.rank && !this.rank.includes("Sifat darajasi yo'q") && this.rank !== "Unvonsiz") ? this.rank : "",
        stavka: this.stavka || "1,00 stavka"
      };
      this.showEditTeacherModal = true;
    },
    async saveTeacherInfo() {
      if (this.isApprovedByOquvProrektor) {
        this.showWarning(
          "O'zgartirish taqiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani tasdiqlagan! O'qituvchi ma'lumotlarini o'zgartirib bo'lmaydi."
        );
        return;
      }
      this.isSavingTeacherInfo = true;
      try {
        const token = localStorage.getItem("token");
        const oquvYili = this.$route.query.oquvYili || localStorage.getItem('selectedOquvYili') || '2026-2027';
        const res = await axios.patch(
          `${API}/shaxsiy-reja/${this.employeeId}/teacher-info`,
          this.editTeacherForm,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { oquvYili }
          }
        );
        if (res.data.success) {
          if (this.editTeacherForm.employeeName) this.teacherName = this.editTeacherForm.employeeName.trim();
          if (this.editTeacherForm.specialty !== undefined) this.specialty = this.editTeacherForm.specialty.trim();
          if (this.editTeacherForm.faculty !== undefined) this.faculty = this.editTeacherForm.faculty.trim();
          if (this.editTeacherForm.dekanName !== undefined) this.dekanName = this.editTeacherForm.dekanName.trim();
          if (this.editTeacherForm.kafedraName !== undefined) this.kafedraName = this.editTeacherForm.kafedraName.trim();
          if (this.editTeacherForm.mudirName !== undefined) this.mudirName = this.editTeacherForm.mudirName.trim();
          if (this.editTeacherForm.degree !== undefined) this.degree = this.editTeacherForm.degree.trim();
          if (this.editTeacherForm.rank !== undefined) this.rank = this.editTeacherForm.rank.trim();
          if (this.editTeacherForm.stavka !== undefined) {
            let st = this.editTeacherForm.stavka.trim();
            if (st && !st.toLowerCase().includes("stavka")) st = `${st} stavka`;
            this.stavka = st;
          }
          this.showEditTeacherModal = false;
          alert("O'qituvchi ma'lumotlari muvaffaqiyatli saqlandi!");
        } else {
          alert(res.data.error || "Saqlashda xatolik yuz berdi");
        }
      } catch (err) {
        console.error("Save teacher info error:", err);
        alert(err.response?.data?.error || err.message || "Saqlashda xatolik yuz berdi");
      } finally {
        this.isSavingTeacherInfo = false;
      }
    },
    async fetchMudirName(deptId = null) {
      const activeDeptId = deptId || this.departmentId || this.$route.query.departmentId;
      if (!activeDeptId) return;
      try {
        const token = localStorage.getItem("token");
        // 1. Fetch official Mudir directly from HEMIS via backend endpoint
        try {
          const mudirRes = await axios.get(`${API}/department-mudir/${activeDeptId}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (mudirRes.data?.success && mudirRes.data?.mudirName) {
            this.mudirName = mudirRes.data.mudirName;
            return;
          }
        } catch (mErr) {
          console.warn("Error calling /api/department-mudir:", mErr.message);
        }

        // 2. Fallback to registered admins
        const res = await axios.get(`${API}/admin/all`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success && res.data.result) {
          const admins = res.data.result;
          const teacher = admins.find(a => 
            String(a.departmentId) === String(activeDeptId) && 
            (String(a.role).toLowerCase().includes("mudir") || String(a.role).toLowerCase().includes("head"))
          );
          if (teacher) {
            this.mudirName = teacher.name;
            return;
          }
        }

        // 3. Fallback to HEMIS employees API
        const types = ['staff', 'teacher'];
        for (const type of types) {
          const resEmp = await axios.get(`${API}/employees`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              type,
              _department: activeDeptId,
              limit: 200
            }
          });
          if (resEmp.data?.success && resEmp.data?.data?.items) {
            const employees = resEmp.data.data.items;
            const mudirEmp = employees.find(e => {
              const posName = (e.staffPosition?.name || e.position?.name || 
                               (typeof e.position === 'string' ? e.position : '') ||
                               (typeof e.staffPosition === 'string' ? e.staffPosition : '')).toLowerCase().trim();
              const posCode = String(e.staffPosition?.code || e.position?.code || '').trim();
              const isNotDeputy = !posName.includes('muovin') && !posName.includes('orinbosar') && !posName.includes('o‘rinbosar') && !posName.includes('o\'rinbosar');
              return isNotDeputy && (posCode === '16' || posName === 'kafedra mudiri' || posName === 'mudir' || (posName.includes('mudir') && !posName.includes('markaz') && !posName.includes('bo\'lim')));
            });
            if (mudirEmp) {
              this.mudirName = mudirEmp.full_name || mudirEmp.name || '';
              return;
            }
          }
        }
      } catch (err) {
        console.error('Error fetching mudir name', err);
      }
      // Ensure mudirName is empty if not found
      this.mudirName = '';
    },
    async fetchDepartmentInfo(deptId = null) {
      const activeDeptId = deptId || this.departmentId || this.$route.query.departmentId;
      if (!activeDeptId) return;
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/departments`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success && res.data.data) {
          const dept = res.data.data.find(d => Number(d.id) === Number(activeDeptId));
          if (dept) {
            this.kafedraName = dept.name;
            if (dept.facultyName) {
              this.faculty = dept.facultyName;
            }
            // Store facultyId for later dean fetch (extract ID if object)
            const rawParent = dept.parent;
            const parentId = (typeof rawParent === 'object' && rawParent) ? (rawParent.id || rawParent._id) : rawParent;
            this.facultyId = parentId ? Number(parentId) : null;
            // Fetch dean info if facultyId available
            if (this.facultyId) {
              this.fetchFacultyInfo(this.facultyId);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching department info", err);
      }
    },
    async fetchFacultyInfo(facultyId = null) {
      let rawId = facultyId || this.facultyId;
      if (!rawId) {
        const dId = this.departmentId || this.$route.query.departmentId;
        if (dId && !isNaN(Number(dId))) {
          rawId = dId;
        }
      }
      if (!rawId) return;
      if (typeof rawId === 'object' && rawId) {
        rawId = rawId.id || rawId._id || null;
      }
      const numFacId = Number(rawId);
      if (isNaN(numFacId) || numFacId <= 0) return;
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/faculty-info/${numFacId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          const data = res.data;
          if (data.facultyName) this.faculty = data.facultyName;
          if (data.deanName) this.dekanName = data.deanName;
        }
      } catch (err) {
        console.error('Error fetching faculty info', err);
      }
    },
    calculateTotals(itemList) {
      const t = {
        maruza: 0,
        amaliy: 0,
        seminar: 0,
        laboratoriya: 0,
        kursIshi: 0,
        kursIshiHimoya: 0,
        oraliq: 0,
        yakuniy: 0,
        boshqaTashqari: 0,
        jamiIchki: 0,
        jamiTashqi: 0,
        jami: 0
      };

      for (const item of itemList) {
        t.maruza += item.maruza || 0;
        t.amaliy += item.amaliy || 0;
        t.seminar += item.seminar || 0;
        t.laboratoriya += item.laboratoriya || 0;
        t.kursIshi += item.kursIshi || 0;
        t.kursIshiHimoya += item.kursIshiHimoya || 0;
        t.oraliq += item.oraliq || 0;
        t.yakuniy += item.yakuniy || 0;
        t.boshqaTashqari += item.boshqaTashqari || 0;
        
        t.jamiIchki += this.getJamiIchki(item);
        t.jamiTashqi += this.getJamiTashqi(item);
        t.jami += this.getJamiTotal(item);
      }

      // Convert all values to nicely formatted or rounded
      Object.keys(t).forEach(k => {
        t[k] = Number(t[k].toFixed(1)) || 0;
      });

      return t;
    },
    isStepClickable(role) {
      if (this.isApprovedByOquvProrektor && role !== 'oquv') {
        return false;
      }
      const userRoleLower = (this.userRole || "").trim().toLowerCase().replace(/[`‘']/g, "'");
      const isAdmin = ["super admin", "superadmin", "admin", "administartor"].includes(userRoleLower);
      const isTeacherRole = ["qituvchi", "o'qituvchi", "teacher", "katta o'qituvchi", "assistent", "assistant", "dotsent", "docent", "professor", "stajyor", "foydalanuvchi", "user"].some(x => userRoleLower.includes(x));
      const isKafedraMudir = ["kafedra mudiri"].includes(userRoleLower);

      // Teacher can always click their own step (even with 0 hours)
      if (role === "teacher" && isTeacherRole) {
        return this.isOwnerTeacher;
      }

      // Kafedra mudiri can click kafedra step even with 0 hours
      if (role === "kafedra" && isKafedraMudir) {
        return true;
      }

      // Admin can always click any step
      if (isAdmin) return true;

      // Others: block if no workload assigned
      if (this.grandTotals.jami === 0) {
        return false;
      }

      if (role === "teacher") {
        return false;
      }
      if (role === "kafedra") {
        return isKafedraMudir;
      }
      if (role === "dekan") {
        return ["dekan"].includes(userRoleLower);
      }
      if (role === "yoshlar") {
        const isYoshlar = userRoleLower.includes("prorektor") && userRoleLower.includes("yoshlar");
        return isYoshlar && (this.planStatus?.dekan === 'approved' || isAdmin);
      }
      if (role === "ilmiy") {
        const isIlmiy = userRoleLower.includes("prorektor") && userRoleLower.includes("ilmiy");
        return isIlmiy && (this.planStatus?.yoshlar === 'approved' || isAdmin);
      }
      if (role === "oquv") {
        const isOquv = userRoleLower.includes("prorektor") && (userRoleLower.includes("o'quv") || userRoleLower.includes("oquv"));
        return isOquv && (this.planStatus?.ilmiy === 'approved' || isAdmin);
      }
      return false;
    },
    showWarning(title, message) {
      this.warningModalTitle = title;
      this.warningModalMessage = message;
      this.showWarningModal = true;
    },
    promptApprovalChange(role) {
      if (this.isApprovedByOquvProrektor && role !== 'oquv') {
        this.showWarning(
          "Reja to'liq tasdiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani rasman tasdiqlagan! Reja to'liq qulflangan, avvalgi bosqichlarni o'zgartirib bo'lmaydi."
        );
        return;
      }
      const userRoleLower = (this.userRole || "").trim().toLowerCase().replace(/[`‘']/g, "'");
      const isTeacherRoleCheck = ["qituvchi", "o'qituvchi", "teacher", "katta o'qituvchi", "assistent", "assistant", "dotsent", "docent", "professor", "stajyor", "foydalanuvchi", "user"].some(x => userRoleLower.includes(x));
      const isKafedraMudirCheck = ["kafedra mudiri"].includes(userRoleLower);

      // Teacher and kafedra mudiri can open modal even with 0 hours
      const rolesAllowedWithZeroHours = 
        (role === "teacher" && isTeacherRoleCheck) || 
        (role === "kafedra" && isKafedraMudirCheck);

      if (!rolesAllowedWithZeroHours) {
        if (this.grandTotals.jami === 0) {
          this.showWarning(
            "Tasdiqlash imkonsiz",
            "Ushbu o'qituvchiga dars biriktirilmagan (jami yuklama 0 soat), shuning uchun shaxsiy ish rejasini tasdiqlash imkoniyati mavjud emas!"
          );
          return;
        }
      }

      const isAdmin = ["super admin", "superadmin", "admin", "administartor"].includes(userRoleLower);


      if (role === "teacher") {
        const isTeacherRole = ["qituvchi", "o'qituvchi", "teacher", "katta o'qituvchi", "assistent", "assistant", "dotsent", "docent", "professor", "stajyor", "foydalanuvchi", "user"].some(x => userRoleLower.includes(x));
        if (isTeacherRole) {
          if (!this.isOwnerTeacher) {
            this.showWarning(
              "Ruxsat etilmagan harakat",
              "Siz faqat o'zingizning shaxsiy ish rejangizni tasdiqlashingiz mumkin!"
            );
            return;
          }
        } else if (!isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda o'qituvchi bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat O'qituvchi o'zi tasdiqlashi kerak."
          );
          return;
        }
      } else if (role === "kafedra") {
        const isKafedraMudir = ["kafedra mudiri"].includes(userRoleLower);
        if (!isKafedraMudir && !isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda kafedra mudiri bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat Kafedra mudiri tasdiqlashi kerak."
          );
          return;
        }
      } else if (role === "dekan") {
        const isDekan = ["dekan", "dean", "fakultet dekani"].some(x => userRoleLower.includes(x));
        if (!isDekan && !isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda dekan bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat Dekan tasdiqlashi kerak."
          );
          return;
        }
      } else if (role === "yoshlar") {
        const isYoshlar = userRoleLower.includes("prorektor") && userRoleLower.includes("yoshlar");
        if (!isYoshlar && !isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda yoshlar ishlari prorektori bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat Yoshlar ishlari bo'yicha prorektor tasdiqlashi kerak."
          );
          return;
        }
        if (!isAdmin && this.planStatus?.dekan !== 'approved') {
          this.showWarning(
            "Dekan tasdig'i kutilmoqda",
            "Ushbu shaxsiy ish rejani tasdiqlash uchun avval Dekan tasdiqlashi shart!"
          );
          return;
        }
      } else if (role === "ilmiy") {
        const isIlmiy = userRoleLower.includes("prorektor") && userRoleLower.includes("ilmiy");
        if (!isIlmiy && !isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda ilmiy ishlari prorektori bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat Ilmiy ishlari bo'yicha prorektor tasdiqlashi kerak."
          );
          return;
        }
        if (!isAdmin && this.planStatus?.yoshlar !== 'approved') {
          this.showWarning(
            "Yoshlar ishlari prorektori tasdig'i kutilmoqda",
            "Ushbu shaxsiy ish rejani tasdiqlash uchun avval Yoshlar ishlari bo'yicha prorektor tasdiqlashi shart!"
          );
          return;
        }
      } else if (role === "oquv") {
        const isOquv = userRoleLower.includes("prorektor") && (userRoleLower.includes("o'quv") || userRoleLower.includes("oquv"));
        if (!isOquv && !isAdmin) {
          this.showWarning(
            "Ruxsat etilmagan harakat",
            "Sizda o'quv ishlari prorektori bosqichini tasdiqlash huquqi yo'q! Bu bosqichni faqat O'quv ishlari bo'yicha prorektor tasdiqlashi kerak."
          );
          return;
        }
        if (!isAdmin && this.planStatus?.ilmiy !== 'approved') {
          this.showWarning(
            "Ilmiy ishlari prorektori tasdig'i kutilmoqda",
            "Ushbu shaxsiy ish rejani tasdiqlash uchun avval Ilmiy ishlari bo'yicha prorektor tasdiqlashi shart!"
          );
          return;
        }
      }

      this.selectedRoleForChange = role;
      this.showApprovalModal = true;
    },
    async updateStepStatus(newStatus) {
      if (this.selectedRoleForChange === 'yoshlar' && newStatus === 'approved') {
        // Avtomatik saqlash: kiritilgan ma'lumotlarni bazaga saqlab keyin tasdiqlaydi
        try {
          const token = localStorage.getItem('token');
          await axios.patch(
            `${API}/shaxsiy-reja/${this.employeeId}/manual`,
            {
              oquvUslubiy: this.oquvUslubiyRows,
              ilmiyTadqiqot: this.ilmiyTadqiqotRows,
              ustozShogird: this.ustozShogirdRows
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (e) {
          console.error("Manual saqlashda xatolik:", e);
        }
      } else if (this.selectedRoleForChange === 'ilmiy' && newStatus === 'approved') {
        // Avtomatik saqlash: kiritilgan ma'lumotlarni bazaga saqlab keyin tasdiqlaydi
        try {
          const token = localStorage.getItem('token');
          await axios.patch(
            `${API}/shaxsiy-reja/${this.employeeId}/manual`,
            {
              oquvUslubiy: this.oquvUslubiyRows,
              ilmiyTadqiqot: this.ilmiyTadqiqotRows,
              ustozShogird: this.ustozShogirdRows
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (e) {
          console.error("Manual saqlashda xatolik:", e);
        }
      } else if (this.selectedRoleForChange === 'oquv' && newStatus === 'approved') {
        // Avtomatik saqlash
        try {
          const token = localStorage.getItem('token');
          await axios.patch(
            `${API}/shaxsiy-reja/${this.employeeId}/manual`,
            {
              oquvUslubiy: this.oquvUslubiyRows,
              ilmiyTadqiqot: this.ilmiyTadqiqotRows,
              ustozShogird: this.ustozShogirdRows
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (e) {
          console.error("Manual saqlashda xatolik:", e);
        }
      }

      try {
        const token = localStorage.getItem("token");
        const res = await axios.patch(
          `${API}/shaxsiy-reja/${this.employeeId}/status`,
          {
            role: this.selectedRoleForChange,
            status: newStatus
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data.success) {
          this.planStatus[this.selectedRoleForChange] = newStatus;
          if (!this.planStatusDates) this.planStatusDates = {};
          if (newStatus === 'approved') {
            this.planStatusDates[this.selectedRoleForChange] = new Date();
          } else {
            delete this.planStatusDates[this.selectedRoleForChange];
          }
          this.showApprovalModal = false;
          await this.generateProrektorQr();
        }
      } catch (err) {
        console.error("Error updating approval status", err);
        const errMsg = err.response?.data?.error || "Holatni o'zgartirishda xatolik yuz berdi";
        this.showWarning("Xatolik", errMsg);
      }
    },
    confirmDeleteSubjectItem(item) {
      if (this.isApprovedByOquvProrektor) {
        this.showWarning(
          "O'chirish taqiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani rasman tasdiqlagan! Fanni o'chirish imkonsiz."
        );
        return;
      }
      this.deleteConfirmSubjectRow = item;
    },
    async doDeleteSubjectItem() {
      if (!this.deleteConfirmSubjectRow) return;
      if (this.isApprovedByOquvProrektor) {
        this.showWarning(
          "O'chirish taqiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani rasman tasdiqlagan! Fanni o'chirish imkonsiz."
        );
        this.deleteConfirmSubjectRow = null;
        return;
      }
      const item = this.deleteConfirmSubjectRow;
      this.isDeletingItem = true;
      try {
        const token = localStorage.getItem("token");
        const oquvYili = this.$route.query.oquvYili || localStorage.getItem('selectedOquvYili') || '2026-2027';
        const res = await axios.delete(`${API}/shaxsiy-reja/${this.employeeId}/item`, {
          headers: { Authorization: `Bearer ${token}` },
          data: {
            yuklamaId: item.yuklamaId,
            taqsimotId: item.taqsimotId,
            subjectName: item.subjectName,
            guruhNomi: item.guruhNomi,
            semestrTuri: item.semestrTuri,
            subjectId: item.subjectId,
            oquvYili
          }
        });
        if (res.data.success) {
          this.deleteConfirmSubjectRow = null;
          await this.fetchData();
        }
      } catch (err) {
        console.error("Error deleting subject item", err);
        alert(err.response?.data?.error || "Fanni o'chirishda xatolik yuz berdi");
      } finally {
        this.isDeletingItem = false;
      }
    },
    emptyRows(n) {
      return Array.from({ length: n }, () => ({ ishTurlari: '', muddati: '', mexanizm: '', reyting: '' }));
    },
    addRow(section) {
      if (this.isApprovedByOquvProrektor) return;
      const key = section === 'oquvUslubiy' ? 'oquvUslubiyRows' : section === 'ilmiyTadqiqot' ? 'ilmiyTadqiqotRows' : 'ustozShogirdRows';
      this[key].push({ ishTurlari: '', muddati: '', mexanizm: '', reyting: '' });
    },
    removeLastRow(section) {
      if (this.isApprovedByOquvProrektor) return;
      const key = section === 'oquvUslubiy' ? 'oquvUslubiyRows' : section === 'ilmiyTadqiqot' ? 'ilmiyTadqiqotRows' : 'ustozShogirdRows';
      if (this[key].length > 0) this[key].pop();
    },
    async saveManualSections() {
      if (this.isApprovedByOquvProrektor) {
        this.showWarning(
          "O'zgartirish taqiqlangan",
          "O'quv ishlari bo'yicha prorektor ushbu shaxsiy rejani tasdiqlagan! Reja ma'lumotlarini o'zgartirib bo'lmaydi."
        );
        return;
      }
      this.savingManual = true;
      try {
        const token = localStorage.getItem('token');
        await axios.patch(
          `${API}/shaxsiy-reja/${this.employeeId}/manual`,
          {
            oquvUslubiy: this.oquvUslubiyRows,
            ilmiyTadqiqot: this.ilmiyTadqiqotRows,
            ustozShogird: this.ustozShogirdRows
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert("Muvaffaqiyatli saqlandi!");
      } catch (err) {
        console.error('Error saving manual sections', err);
        alert(err.response?.data?.error || 'Saqlashda xatolik yuz berdi!');
      } finally {
        this.savingManual = false;
      }
    },
    exportToExcel() {
      const oquvYili = "2026-2027";
      const name    = this.teacherName || "O'qituvchi";
      const kafedra = this.kafedraName || "—";
      const stavka  = this.stavka      || "—";
      const gt      = this.grandTotals;

      const S = { // clean black and white inline styles in Times New Roman
        td:    `border:1px solid #000000;padding:8px 10px;vertical-align:middle;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000;mso-wrap-text:wrap`,
        tdC:   `border:1px solid #000000;padding:8px 10px;vertical-align:middle;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000;text-align:center;mso-wrap-text:wrap`,
        thH:   `border:1.5px solid #000000;padding:10px 12px;vertical-align:middle;font-size:13pt;font-family:'Times New Roman',Times,serif;font-weight:bold;text-align:center;color:#000000;background:#ffffff;mso-pattern:#ffffff none`,
        thB:   `border:1.5px solid #000000;padding:10px 12px;vertical-align:middle;font-size:13pt;font-family:'Times New Roman',Times,serif;font-weight:bold;text-align:center;color:#000000;background:#ffffff;mso-pattern:#ffffff none`,
        total: `border:1.5px solid #000000;padding:10px 12px;vertical-align:middle;font-size:12pt;font-family:'Times New Roman',Times,serif;font-weight:bold;text-align:center;color:#000000;background:#ffffff;mso-pattern:#ffffff none`,
        alt:   `border:1px solid #000000;padding:8px 10px;vertical-align:middle;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000;text-align:center`,
        altL:  `border:1px solid #000000;padding:8px 10px;vertical-align:middle;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000`
      };

      // ── I. Main table rows ──────────────────────────────────
      let mainRows = "";
      let rn = 1;
      for (const item of (this.items || [])) {
        const ichki = this.getJamiIchki(item);
        const tashqi = this.getJamiTashqi(item);
        const jami   = Number((ichki + tashqi).toFixed(1));
        if (jami === 0) continue;
        mainRows += `<tr style="height:36px">
          <td style="${S.tdC}">${rn++}</td>
          <td style="${S.td}">${item.subjectName || ""}</td>
          <td style="${S.tdC}">${item.specialtyName || ""}</td>
          <td style="${S.tdC}">${this.getDisplayGuruh(item)}</td>
          <td style="${S.tdC}">${this.getKurs(item)}</td>
          ${this.activeAuditoryFields.map(f => `<td style="${S.tdC}">${item[f.key] || 0}</td>`).join("")}
          ${this.activeOutAuditoryFields.map(f => `<td style="${S.tdC}">${item[f.key] || 0}</td>`).join("")}
          <td style="${S.tdC};font-weight:bold">${ichki}</td>
          <td style="${S.tdC};font-weight:bold">${tashqi}</td>
          <td style="${S.tdC};font-weight:bold">${jami}</td>
        </tr>`;
      }
      const totalCols = 5 + this.activeAuditoryFields.length + this.activeOutAuditoryFields.length + 3;
      mainRows += `<tr style="height:36px">
        <td colspan="5" style="${S.total};text-align:right">UMUMIY JAMI:</td>
        ${this.activeAuditoryFields.map(f => `<td style="${S.total}">${gt[f.key] || 0}</td>`).join("")}
        ${this.activeOutAuditoryFields.map(f => `<td style="${S.total}">${gt[f.key] || 0}</td>`).join("")}
        <td style="${S.total}">${gt.jamiIchki || 0}</td>
        <td style="${S.total}">${gt.jamiTashqi || 0}</td>
        <td style="${S.total};font-size:13pt">${gt.jami || 0}</td>
      </tr>`;

      // ── Manual rows builder ─────────────────────────────────
      const buildManualRows = (rows) => rows.filter(r => r.ishTurlari || r.muddati || r.mexanizm || r.reyting).map((r, i) => {
        return `<tr style="height:40px">
          <td style="${S.tdC}">${i + 1}</td>
          <td style="${S.td}">${r.ishTurlari || ""}</td>
          <td style="${S.tdC}">${r.muddati || ""}</td>
          <td style="${S.td}" colspan="${totalCols - 4}">${r.mexanizm || ""}</td>
          <td style="${S.tdC};font-weight:bold">${r.reyting || ""}</td>
        </tr>`;
      }).join("") || `<tr style="height:36px"><td colspan="${totalCols}" style="${S.tdC};color:#555555;font-style:italic">Ma'lumot kiritilmagan</td></tr>`;

      const auditoryHeaders = this.activeAuditoryFields.map(f => `<th style="${S.thH}">${f.label}</th>`).join("");
      const outHeaders      = this.activeOutAuditoryFields.map(f => `<th style="${S.thH}">${f.label}</th>`).join("");

      const leftColspan = Math.floor(totalCols / 2);
      const rightColspan = totalCols - leftColspan - 1;

      const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8">
        <!--[if gte mso 9]><xml>
          <x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
            <x:Name>Shaxsiy ish reja</x:Name>
            <x:WorksheetOptions>
              <x:DisplayGridlines/>
              <x:Print><x:FitWidth/><x:Orientation>Landscape</x:Orientation></x:Print>
            </x:WorksheetOptions>
          </x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook>
        </xml><![endif]-->
        <style>
          body  { font-family:'Times New Roman',Times,serif; font-size:12pt; color:#000000; }
          table { border-collapse:collapse; }
          td,th { mso-wrap-text:wrap; }
        </style>
      </head>
      <body>

      <table style="border-collapse:collapse; font-family:'Times New Roman', Times, serif; font-size:12pt; color:#000000; width:100%">
        <!-- Column width definitions -->
        <col style="width:50px"/>
        <col style="width:280px"/>
        <col style="width:150px"/>
        <col style="width:140px"/>
        <col style="width:60px"/>
        ${this.activeAuditoryFields.map(() => `<col style="width:90px"/>`).join("")}
        ${this.activeOutAuditoryFields.map(() => `<col style="width:90px"/>`).join("")}
        <col style="width:100px"/>
        <col style="width:100px"/>
        <col style="width:110px"/>

        <!-- ═══════════════ SARLAVHA ═══════════════ -->
        <tr style="height:28px">
          <td colspan="${totalCols}" style="border:none;text-align:center;font-size:12pt;font-weight:bold;font-family:'Times New Roman',Times,serif;color:#000000;letter-spacing:0.5px">
            O'ZBEKISTON RESPUBLIKASI OLIY TA'LIM, FAN VA INNOVATSIYALAR VAZIRLIGI
          </td>
        </tr>
        <tr style="height:48px">
          <td colspan="${totalCols}" style="border:none;text-align:center;font-size:22pt;font-weight:bold;font-family:'Times New Roman',Times,serif;color:#000000">
            SHAXSIY ISH REJA
          </td>
        </tr>
        <tr style="height:28px">
          <td colspan="${totalCols}" style="border:none;text-align:center;font-size:14pt;font-weight:bold;font-family:'Times New Roman',Times,serif;color:#000000">
            ${oquvYili} O'quv yili
          </td>
        </tr>
        <tr style="height:20px">
          <td colspan="${totalCols}" style="border:none">&nbsp;</td>
        </tr>

        <!-- ═══════════════ O'QITUVCHI MA'LUMOTLARI ═══════════════ -->
        <tr style="height:36px">
          <td style="border:1.5px solid #000000;padding:8px 12px;font-weight:bold;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000">F.I.Sh:</td>
          <td colspan="${totalCols - 3}" style="border:1.5px solid #000000;padding:8px 12px;font-weight:bold;font-size:14pt;font-family:'Times New Roman',Times,serif;color:#000000">${name}</td>
          <td style="border:1.5px solid #000000;padding:8px 12px;font-weight:bold;font-size:12pt;text-align:center;font-family:'Times New Roman',Times,serif;color:#000000">Stavka:</td>
          <td style="border:1.5px solid #000000;padding:8px 12px;font-weight:bold;font-size:12pt;text-align:center;font-family:'Times New Roman',Times,serif;color:#000000">${stavka}</td>
        </tr>
        <tr style="height:36px">
          <td style="border:1.5px solid #000000;padding:8px 12px;font-weight:bold;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000">Kafedra:</td>
          <td colspan="${totalCols - 1}" style="border:1.5px solid #000000;padding:8px 12px;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000">${kafedra}</td>
        </tr>
        <tr style="height:24px">
          <td colspan="${totalCols}" style="border:none">&nbsp;</td>
        </tr>

        <!-- ═══════════════ I. ASOSIY JADVAL ═══════════════ -->
        <tr style="height:42px">
          <td colspan="${totalCols}" style="${S.thH};font-size:14pt;letter-spacing:0.5px;border:1.5px solid #000000">
            I. AUDITORIYA VA AUDITORIYADAN TASHQARI MASHG'ULOTLAR
          </td>
        </tr>
        <tr style="height:48px">
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">#</th>
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Fan nomi</th>
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Ta'lim yo'nalishi</th>
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Guruh</th>
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Kurs</th>
          ${this.activeAuditoryFields.length ? `<th style="${S.thH};border:1.5px solid #000000" colspan="${this.activeAuditoryFields.length}">Auditoriya mashg'uloti (soat)</th>` : ''}
          ${this.activeOutAuditoryFields.length ? `<th style="${S.thH};border:1.5px solid #000000" colspan="${this.activeOutAuditoryFields.length}">Auditoriyadan tashqari (soat)</th>` : ''}
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Jami auditoriya</th>
          <th style="${S.thH};border:1.5px solid #000000" rowspan="2">Jami auditoriya tashqi</th>
        </tr>
        <tr style="height:40px">
          ${auditoryHeaders || ''}
          ${outHeaders || ''}
        </tr>
        ${mainRows}

        <tr style="height:24px">
          <td colspan="${totalCols}" style="border:none">&nbsp;</td>
        </tr>

        <!-- ═══════════════ II. O'QUV-USLUBIY ═══════════════ -->
        <tr style="height:42px">
          <td colspan="${totalCols}" style="${S.thB};font-size:14pt;border:1.5px solid #000000">
            II. O'QUV-USLUBIY ISHLARI
          </td>
        </tr>
        <tr style="height:42px">
          <th style="${S.thB};border:1.5px solid #000000">№</th>
          <th style="${S.thB};border:1.5px solid #000000">Ish turlari</th>
          <th style="${S.thB};border:1.5px solid #000000">Bajarish muddati</th>
          <th style="${S.thB};border:1.5px solid #000000" colspan="${totalCols - 4}">Amalga oshirish mexanizmi</th>
          <th style="${S.thB};border:1.5px solid #000000">To'plagan reyting bali</th>
        </tr>
        ${buildManualRows(this.oquvUslubiyRows)}

        <tr style="height:24px">
          <td colspan="${totalCols}" style="border:none">&nbsp;</td>
        </tr>

        <!-- ═══════════════ III. ILMIY-TADQIQOT ═══════════════ -->
        <tr style="height:42px">
          <td colspan="${totalCols}" style="${S.thB};font-size:14pt;border:1.5px solid #000000">
            III. ILMIY-TADQIQOT ISHLARI
          </td>
        </tr>
        <tr style="height:42px">
          <th style="${S.thB};border:1.5px solid #000000">№</th>
          <th style="${S.thB};border:1.5px solid #000000">Ish turlari</th>
          <th style="${S.thB};border:1.5px solid #000000">Bajarish muddati</th>
          <th style="${S.thB};border:1.5px solid #000000" colspan="${totalCols - 4}">Amalga oshirish mexanizmi</th>
          <th style="${S.thB};border:1.5px solid #000000">To'plagan reyting bali</th>
        </tr>
        ${buildManualRows(this.ilmiyTadqiqotRows)}

        <tr style="height:24px">
          <td colspan="${totalCols}" style="border:none">&nbsp;</td>
        </tr>

        <!-- ═══════════════ IV. USTOZ-SHOGIRD ═══════════════ -->
        <tr style="height:42px">
          <td colspan="${totalCols}" style="${S.thB};font-size:14pt;border:1.5px solid #000000">
            IV. "USTOZ-SHOGIRD" ISHLARI
          </td>
        </tr>
        <tr style="height:42px">
          <th style="${S.thB};border:1.5px solid #000000">№</th>
          <th style="${S.thB};border:1.5px solid #000000">Ish turlari</th>
          <th style="${S.thB};border:1.5px solid #000000">Bajarish muddati</th>
          <th style="${S.thB};border:1.5px solid #000000" colspan="${totalCols - 4}">Amalga oshirish mexanizmi</th>
          <th style="${S.thB};border:1.5px solid #000000">To'plagan reyting bali</th>
        </tr>
        ${buildManualRows(this.ustozShogirdRows)}

        <!-- ═══════════════ IMZO ═══════════════ -->
        <tr style="height:32px"><td style="border:none" colspan="${totalCols}">&nbsp;</td></tr>
        <tr style="height:38px">
          <td colspan="${leftColspan}" style="border-top:1.5px solid #000000;border-bottom:none;border-left:none;border-right:none;padding:10px 0;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000;font-weight:bold">
            <b>O'qituvchi:</b> &nbsp; ${name}
          </td>
          <td colspan="1" style="border:none">&nbsp;</td>
          <td colspan="${rightColspan}" style="border-top:1.5px solid #000000;border-bottom:none;border-left:none;border-right:none;padding:10px 0;font-size:12pt;font-family:'Times New Roman',Times,serif;color:#000000;font-weight:bold">
            <b>Kafedra mudiri:</b> &nbsp; ${this.mudirName || "_______________________"}
          </td>
        </tr>
        <tr style="height:24px">
          <td colspan="${leftColspan}" style="border:none;padding:2px 0;font-size:11pt;font-family:'Times New Roman',Times,serif;color:#333333">Imzo: _________________  Sana: «___» ________ 2026 y.</td>
          <td colspan="1" style="border:none">&nbsp;</td>
          <td colspan="${rightColspan}" style="border:none;padding:2px 0;font-size:11pt;font-family:'Times New Roman',Times,serif;color:#333333">Imzo: _________________  Sana: «___» ________ 2026 y.</td>
        </tr>
      </table>

      </body></html>`;

      const blob = new Blob(["\ufeff" + html], { type: "application/vnd.ms-excel;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `shaxsiy_reja_${name.replace(/\s+/g, "_")}_${oquvYili}.xls`;
      a.click();
      URL.revokeObjectURL(url);
    },
    buildDocCoverContent(isWord = false) {
      const oquvYili = "2026-2027";
      const name = this.teacherName || "O'qituvchi";
      const kafedra = this.kafedraName || "—";
      const faculty = this.faculty || "—";
      const degree = this.degree || "Darajasiz";
      const rank = this.rank || "Unvonsiz";
      const position = this.position || "O'qituvchi";

      const qrImgTag = (this.planStatus?.oquv === 'approved' && this.prorektorQrCodeUrl) ? (
        isWord
          ? `<img src="prorektor_qr.png" width="75" height="75" style="width:75px;height:75px;display:block;margin:3px auto;border:none;" alt="QR-kod" />`
          : `<img src="${this.prorektorQrCodeUrl}" style="width:72px;height:72px;display:block;margin:3px auto;" alt="QR-kod" />`
      ) : '';

      return `
        <table data-layout="true" style="width: 100%; border: none; border-collapse: collapse; margin-bottom: 12px;">
          <tr>
            <td style="border: none; width: 42%;">&nbsp;</td>
            <td align="right" style="border: none; width: 58%; text-align: right; padding: 0;">
              <p style="text-align: right; line-height: 1.15; margin: 0; font-family: 'Times New Roman', serif; font-size: 9.5pt;">
                O'zbekiston Respublikasi OO'MTV 2018-yil<br/>
                10-sentyabrdagi 20-2018-sonli buyrug'i ilovasi va<br/>
                OO'MTV 2017-yil 26-dekabrdagi 941-son buyrug'i<br/>
                bilan tasdiqlangan "Tarmoq-tarif malaka<br/>
                ma'lumotnomasi" asosida ishlab chiqildi.
              </p>
            </td>
          </tr>
        </table>

        <div style="width: 85%; margin: 0 auto 10px auto; text-align: center;">
          <div style="font-size: 13pt; font-weight: bold; border-bottom: 1.5px solid #000000; padding-bottom: 5px; line-height: 1.35; display: block;">
            Oliy ta'lim, fan va innovatsiyalar vazirligi
          </div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; padding-top: 3px;">
            Vazirlik yoki idora nomi
          </div>
        </div>

        <div style="width: 85%; margin: 0 auto 10px auto; text-align: center;">
          <div style="font-size: 13pt; font-weight: bold; border-bottom: 1.5px solid #000000; padding-bottom: 5px; line-height: 1.35; display: block;">
            Termiz davlat muhandislik va agrotexnologiyalar universiteti
          </div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; padding-top: 3px;">
            OTM nomi
          </div>
        </div>

        <div style="width: 85%; margin: 0 auto 10px auto; text-align: center;">
          <div style="font-size: 13pt; font-weight: bold; border-bottom: 1.5px solid #000000; padding-bottom: 5px; line-height: 1.35; display: block;">
            ${faculty}
          </div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; padding-top: 3px;">
            Fakultet nomi
          </div>
        </div>

        <div style="width: 85%; margin: 0 auto 14px auto; text-align: center;">
          <div style="font-size: 13pt; font-weight: bold; border-bottom: 1.5px solid #000000; padding-bottom: 5px; line-height: 1.35; display: block;">
            ${kafedra}
          </div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; padding-top: 3px;">
            Kafedra nomi
          </div>
        </div>

        <table data-layout="true" style="width: 100%; border-collapse: collapse; border: none; margin-bottom: 14px; font-size: 10pt; line-height: 1.3;">
          <tr>
            <td style="width: 33%; text-align: center; vertical-align: top; border: none; padding: 4px;">
              <b>"TASDIQLAYMAN"</b><br/>
              O'quv ishlari bo'yicha prorektor<br/>
              ${this.planStatus?.oquv === 'approved' ? `
                B.Primkulov<br/>
                <b style="font-size:10pt;display:inline-block;margin:2px 0;">"TASDIQLANDI"</b><br/>
                ${qrImgTag}
              ` : `
                ___________ B.Primkulov<br/>
                «___» ________ 2026 y.
              `}
            </td>
            <td style="width: 33%; text-align: center; vertical-align: top; border: none; padding: 4px;">
              <b>"KELISHILDI"</b><br/>
              Ilmiy ishlar va innovatsiyalar<br/>
              bo'yicha prorektor<br/>
              ${this.planStatus?.ilmiy === 'approved' ? '' : '___________ '}M.Urozov<br/>
              ${this.planStatus?.ilmiy === 'approved' ? '<b style="font-size:10pt;display:inline-block;margin-top:2px;">"KELISHILDI"</b>' : '«___» ________ 2026 y.'}
            </td>
            <td style="width: 33%; text-align: center; vertical-align: top; border: none; padding: 4px;">
              <b>"KELISHILDI"</b><br/>
              Yoshlar masalalari va<br/>
              ma'naviy-ma'rifiy ishlar<br/>
              bo'yicha 1-prorektor<br/>
              ${this.planStatus?.yoshlar === 'approved' ? '' : '___________ '}M.Majitov<br/>
              ${this.planStatus?.yoshlar === 'approved' ? '<b style="font-size:10pt;display:inline-block;margin-top:2px;">"KELISHILDI"</b>' : '«___» ________ 2026 y.'}
            </td>
          </tr>
        </table>

        <div style="text-align: center; font-size: 12pt; font-weight: bold; margin-bottom: 4px;">
          ${oquvYili} o'quv yili uchun
        </div>
        <div style="font-size: 14pt; font-weight: bold; text-align: center; margin-bottom: 12px;">
          PROFESSOR-O'QITUVCHI SHAXSIY ISH REJASI
        </div>

        <div style="width: 90%; margin: 0 auto 6px auto; text-align: center;">
          <div style="border-bottom: 1.5px solid #000000; font-weight: bold; font-size: 12pt; padding-bottom: 5px; line-height: 1.35; display: block;">${name}</div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; margin-top: 3px;">O'qituvchining ismi-sharifi</div>
        </div>

        <div style="width: 90%; margin: 0 auto 6px auto; text-align: center;">
          <div style="border-bottom: 1.5px solid #000000; font-weight: bold; font-size: 11pt; padding-bottom: 5px; line-height: 1.35; display: block;">${degree} / ${rank}</div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; margin-top: 3px;">Ilmiy daraja va unvoni</div>
        </div>

        <div style="width: 90%; margin: 0 auto 12px auto; text-align: center;">
          <div style="border-bottom: 1.5px solid #000000; font-weight: bold; font-size: 11pt; padding-bottom: 5px; line-height: 1.35; display: block;">${position}</div>
          <div style="font-size: 8.5pt; font-style: italic; color: #333333; margin-top: 3px;">lavozimi</div>
        </div>

        <table data-layout="true" style="width: 100%; border-collapse: collapse; border: none; font-size: 9.5pt; margin-bottom: 14px;">
          <tr>
            <td style="width: 48%; vertical-align: top; border: none; padding: 4px; line-height: 1.4;">
              Fakultet dekani: ${this.dekanName || ""}
            </td>
            <td style="width: 4%; border: none; padding: 4px;">&nbsp;</td>
            <td style="width: 48%; vertical-align: top; border: none; line-height: 1.4; padding: 4px;">
              ${getKafedraDecisionCoverHtml(this.kafedraName)}<br/><br/>
              Kafedra mudiri: ${this.mudirName || ""}
            </td>
          </tr>
        </table>

        <div style="text-align: center; font-size: 10pt; margin-top: 8px;">
          Shaxsiy ish rejani qabul qildi: ${name}
        </div>
      `;
    },

    buildDocTableIStructure(isWord = false) {
      const kt = this.kuzgiTotals;
      const bt = this.bahorgiTotals;
      const gt = this.grandTotals;
      const activeAud = this.activeAuditoryFields || [];
      const activeOut = this.activeOutAuditoryFields || [];
      const totalCols = 5 + (activeAud.length ? activeAud.length + 1 : 0) + (activeOut.length ? activeOut.length + 1 : 0) + 1;

      const makeRow = (item, index) => {
        const jamiIchki = this.getJamiIchki(item);
        const jamiTashqi = this.getJamiTashqi(item);
        const jamiTotal = this.getJamiTotal(item);
        const tdC = 'border:1px solid #000; text-align:center; padding:2px 2px 5.5px 2px; font-family:Times New Roman,Times,serif; font-size:8pt; vertical-align:middle; line-height:1.2;';
        const tdL = 'border:1px solid #000; text-align:left; padding:2px 3px 5.5px 3px; font-family:Times New Roman,Times,serif; font-size:8pt; vertical-align:middle; line-height:1.2;';
        const tdB = 'border:1px solid #000; text-align:center; padding:2px 2px 5.5px 2px; font-family:Times New Roman,Times,serif; font-size:8pt; font-weight:bold; vertical-align:middle; line-height:1.2;';
        let r = `<tr>
          <td style="${tdC}">${index + 1}</td>
          <td style="${tdL}">${item.subjectName || ""}</td>
          <td style="${tdL}">${item.specialtyName || ""}</td>
          <td style="${tdC}">${this.getDisplayGuruh(item)}</td>
          <td style="${tdC}">${this.getKurs(item)}</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(f => {
            r += `<td style="${tdC}">${this.formatVal(item[f.key])}</td>`;
          });
          r += `<td style="${tdB}">${this.formatVal(jamiIchki)}</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(f => {
            r += `<td style="${tdC}">${this.formatVal(item[f.key])}</td>`;
          });
          r += `<td style="${tdB}">${this.formatVal(jamiTashqi)}</td>`;
        }
        r += `<td style="${tdB}">${this.formatVal(jamiTotal)}</td></tr>`;
        return r;
      };


      const makeHeader = () => {
        const thBase = 'border: 1px solid #000; padding: 2.5px 2px 4.5px 2px; text-align: center; background-color: #f2f2f2; font-family: Times New Roman, Times, serif; font-size: 7.5pt; font-weight: bold; vertical-align: middle; line-height: 1.15;';
        const thSub  = 'border: 1px solid #000; padding: 2px 1.5px 4px 1.5px; text-align: center; background-color: #f2f2f2; font-family: Times New Roman, Times, serif; font-size: 7pt; font-weight: normal; vertical-align: middle; line-height: 1.1;';

        const formatSubLabel = (label) => {
          if (!label) return '';
          return label
            .replace(" mashg'ulot", "")
            .replace(" himoyasi", "")
            .replace(" nazorat", "")
            .replace("Auditoriyadan tashqari boshqa", "Tashqari boshqa");
        };

        let th = `<thead style="display: table-header-group;">
          <tr>
            <th rowspan="2" style="${thBase} width:3%;">#</th>
            <th rowspan="2" style="${thBase} width:23%; text-align:left;">Fan nomi</th>
            <th rowspan="2" style="${thBase} width:19%; text-align:left;">Ta'lim yo'nalishi</th>
            <th rowspan="2" style="${thBase} width:13%;">Guruh</th>
            <th rowspan="2" style="${thBase} width:4%;">Kurs</th>`;
        if (activeAud.length > 0) {
          th += `<th colspan="${activeAud.length + 1}" style="${thBase}">Auditoriya mashg'uloti</th>`;
        }
        if (activeOut.length > 0) {
          th += `<th colspan="${activeOut.length + 1}" style="${thBase}">Auditoriyadan tashqari mashg'ulotlar</th>`;
        }
        th += `<th rowspan="2" style="${thBase} width:5%;">Jami</th></tr>
          <tr>`;
        if (activeAud.length > 0) {
          activeAud.forEach(f => {
            th += `<th style="${thSub}">${formatSubLabel(f.label)}</th>`;
          });
          th += `<th style="${thSub} font-weight:bold;">Jami aud</th>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(f => {
            th += `<th style="${thSub}">${formatSubLabel(f.label)}</th>`;
          });
          th += `<th style="${thSub} font-weight:bold;">Jami tashqari</th>`;
        }
        th += `</tr></thead>`;
        return th;
      };

      let kuzgiTotalsHtml = `
        <tr style="background-color: #f9f9f9; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">Jami (reja):</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(f => {
            kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(kt[f.key])}</td>`;
          });
          kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(kt.jamiIchki)}</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(f => {
            kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(kt[f.key])}</td>`;
          });
          kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(kt.jamiTashqi)}</td>`;
        }
        kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(kt.jami)}</td></tr>`;

      kuzgiTotalsHtml += `
        <tr style="background-color: #f9f9f9; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">Amalda:</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(() => { kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(() => { kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        kuzgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td></tr>`;

      let bahorgiTotalsHtml = `
        <tr style="background-color: #f9f9f9; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">Jami (reja):</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(f => {
            bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(bt[f.key])}</td>`;
          });
          bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(bt.jamiIchki)}</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(f => {
            bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(bt[f.key])}</td>`;
          });
          bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(bt.jamiTashqi)}</td>`;
        }
        bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(bt.jami)}</td></tr>`;

      bahorgiTotalsHtml += `
        <tr style="background-color: #f9f9f9; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">Amalda:</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(() => { bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(() => { bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        bahorgiTotalsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td></tr>`;

      let grandTotalRowsHtml = `
        <tr style="background-color: #e2e8f0; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">O'quv yili bo'yicha jami reja:</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(f => {
            grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(gt[f.key])}</td>`;
          });
          grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(gt.jamiIchki)}</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(f => {
            grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(gt[f.key])}</td>`;
          });
          grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(gt.jamiTashqi)}</td>`;
        }
        grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px; font-size: 7.8pt;">${this.formatVal(gt.jami)}</td></tr>`;

      grandTotalRowsHtml += `
        <tr style="background-color: #e2e8f0; font-weight: bold; page-break-inside: avoid;">
          <td colspan="5" style="border: 1px solid #000; text-align: right; padding: 2px 3px 5.5px 3px; font-size: 7.8pt;">Amalda:</td>`;
        if (activeAud.length > 0) {
          activeAud.forEach(() => { grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        if (activeOut.length > 0) {
          activeOut.forEach(() => { grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`; });
          grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td>`;
        }
        grandTotalRowsHtml += `<td style="border: 1px solid #000; text-align: center; font-weight: bold; padding: 2px 2px 5.5px 2px;">&nbsp;</td></tr>`;

      const kuzgiLen = this.kuzgiItems?.length || 0;
      const bahorgiLen = this.bahorgiItems?.length || 0;
      const pages = [];
      const theadHtml = makeHeader();

      if (isWord) {
        let rowsHtml = '';
        if (kuzgiLen > 0) {
          rowsHtml += `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5pt 4pt;">Kuzgi semestr</td>
            </tr>`;
          this.kuzgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += kuzgiTotalsHtml;
        }
        if (bahorgiLen > 0) {
          rowsHtml += `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5pt 4pt;">Bahorgi semestr</td>
            </tr>`;
          this.bahorgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += bahorgiTotalsHtml;
        }
        rowsHtml += grandTotalRowsHtml;

        pages.push({
          title: "I. O'quv ishlari",
          subtitle: "O'quv mashg'ulot turlari",
          theadHtml,
          rowsHtml
        });
        return { pages, totalCols };
      }

      const chunkItems = (items, maxLen) => {
        if (!items || items.length <= maxLen) return [items || []];
        const mid = Math.ceil(items.length / 2);
        return [items.slice(0, mid), items.slice(mid)];
      };

      if (bahorgiLen === 0) {
        if (kuzgiLen <= 16) {
          let rowsHtml = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5pt 4pt;">Kuzgi semestr</td>
            </tr>`;
          this.kuzgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += kuzgiTotalsHtml;
          rowsHtml += grandTotalRowsHtml;
          pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr)", theadHtml, rowsHtml });
        } else {
          const [part1, part2] = chunkItems(this.kuzgiItems, 14);
          let p1Rows = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr (1-qism)</td>
            </tr>`;
          part1.forEach((it, idx) => { p1Rows += makeRow(it, idx); });
          pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr, 1-qism)", theadHtml, rowsHtml: p1Rows });

          let p2Rows = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr (davomi)</td>
            </tr>`;
          part2.forEach((it, idx) => { p2Rows += makeRow(it, part1.length + idx); });
          p2Rows += kuzgiTotalsHtml;
          p2Rows += grandTotalRowsHtml;
          pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr, davomi)", theadHtml, rowsHtml: p2Rows });
        }
      } else if (kuzgiLen === 0) {
        if (bahorgiLen <= 16) {
          let rowsHtml = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr</td>
            </tr>`;
          this.bahorgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += bahorgiTotalsHtml;
          rowsHtml += grandTotalRowsHtml;
          pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr)", theadHtml, rowsHtml });
        } else {
          const [part1, part2] = chunkItems(this.bahorgiItems, 14);
          let p1Rows = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr (1-qism)</td>
            </tr>`;
          part1.forEach((it, idx) => { p1Rows += makeRow(it, idx); });
          pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr, 1-qism)", theadHtml, rowsHtml: p1Rows });

          let p2Rows = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr (davomi)</td>
            </tr>`;
          part2.forEach((it, idx) => { p2Rows += makeRow(it, part1.length + idx); });
          p2Rows += bahorgiTotalsHtml;
          p2Rows += grandTotalRowsHtml;
          pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr, davomi)", theadHtml, rowsHtml: p2Rows });
        }
      } else {
        if (kuzgiLen + bahorgiLen <= 10) {
          let rowsHtml = `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr</td>
            </tr>`;
          this.kuzgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += kuzgiTotalsHtml;
          rowsHtml += `
            <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
              <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr</td>
            </tr>`;
          this.bahorgiItems.forEach((it, idx) => { rowsHtml += makeRow(it, idx); });
          rowsHtml += bahorgiTotalsHtml;
          rowsHtml += grandTotalRowsHtml;
          pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari", theadHtml, rowsHtml });
        } else {
          // Kuzgi semester
          if (kuzgiLen <= 16) {
            let p1Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr</td>
              </tr>`;
            this.kuzgiItems.forEach((it, idx) => { p1Rows += makeRow(it, idx); });
            p1Rows += kuzgiTotalsHtml;
            pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr)", theadHtml, rowsHtml: p1Rows });
          } else {
            const [kPart1, kPart2] = chunkItems(this.kuzgiItems, 14);
            let kp1Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr (1-qism)</td>
              </tr>`;
            kPart1.forEach((it, idx) => { kp1Rows += makeRow(it, idx); });
            pages.push({ title: "I. O'quv ishlari", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr, 1-qism)", theadHtml, rowsHtml: kp1Rows });

            let kp2Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Kuzgi semestr (davomi)</td>
              </tr>`;
            kPart2.forEach((it, idx) => { kp2Rows += makeRow(it, kPart1.length + idx); });
            kp2Rows += kuzgiTotalsHtml;
            pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Kuzgi semestr, davomi)", theadHtml, rowsHtml: kp2Rows });
          }

          // Bahorgi semester
          if (bahorgiLen <= 16) {
            let p2Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr</td>
              </tr>`;
            this.bahorgiItems.forEach((it, idx) => { p2Rows += makeRow(it, idx); });
            p2Rows += bahorgiTotalsHtml;
            p2Rows += grandTotalRowsHtml;
            pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr)", theadHtml, rowsHtml: p2Rows });
          } else {
            const [bPart1, bPart2] = chunkItems(this.bahorgiItems, 14);
            let bp1Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr (1-qism)</td>
              </tr>`;
            bPart1.forEach((it, idx) => { bp1Rows += makeRow(it, idx); });
            pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr, 1-qism)", theadHtml, rowsHtml: bp1Rows });

            let bp2Rows = `
              <tr style="background-color: #f2f2f2; font-weight: bold; font-size: 8.5pt; page-break-inside: avoid;">
                <td colspan="${totalCols}" style="border: 1px solid #000; text-align: left; padding: 2.5px 4pt 5.5px 4pt;">Bahorgi semestr (davomi)</td>
              </tr>`;
            bPart2.forEach((it, idx) => { bp2Rows += makeRow(it, bPart1.length + idx); });
            bp2Rows += bahorgiTotalsHtml;
            bp2Rows += grandTotalRowsHtml;
            pages.push({ title: "I. O'quv ishlari (davomi)", subtitle: "O'quv mashg'ulot turlari (Bahorgi semestr, davomi)", theadHtml, rowsHtml: bp2Rows });
          }
        }
      }

      return { pages, totalCols };
    },

    buildDocManualRowsHtml(rows, isCompact = false) {
      if (!rows || rows.length === 0) {
        return `<tr><td colspan="5" style="border: 1px solid #000; text-align: center; padding: 4pt; color: #666; font-size: 8pt;">Ma'lumot kiritilmagan</td></tr>`;
      }
      const fs = isCompact ? '7.5pt' : '8pt';
      const padC = isCompact ? '2px 3.5px 5.5px 3.5px' : '2.5px 4px 6px 4px';
      const padL = isCompact ? '2px 4px 5.5px 4px' : '2.5px 5px 6px 5px';
      const lh = isCompact ? '1.15' : '1.2';
      return rows.map((r, i) => `
        <tr>
          <td style="border:1px solid #000; text-align:center; width:5%; padding:${padC}; font-family:Times New Roman,Times,serif; font-size:${fs}; vertical-align:middle; line-height:${lh};">${i + 1}</td>
          <td style="border:1px solid #000; text-align:left; width:45%; padding:${padL}; font-family:Times New Roman,Times,serif; font-size:${fs}; vertical-align:middle; line-height:${lh};">${r.ishTurlari || ""}</td>
          <td style="border:1px solid #000; text-align:center; width:15%; padding:${padC}; font-family:Times New Roman,Times,serif; font-size:${fs}; vertical-align:middle; line-height:${lh};">${r.muddati || ""}</td>
          <td style="border:1px solid #000; text-align:left; width:25%; padding:${padL}; font-family:Times New Roman,Times,serif; font-size:${fs}; vertical-align:middle; line-height:${lh};">${r.mexanizm || ""}</td>
          <td style="border:1px solid #000; text-align:center; font-weight:bold; width:10%; padding:${padC}; font-family:Times New Roman,Times,serif; font-size:${fs}; vertical-align:middle; line-height:${lh};">${r.reyting || ""}</td>
        </tr>`).join("");
    },

    buildDocSectionIIHtml(isWord = false) {
      const th = 'border:1px solid #000; padding:3px 4px 6px 4px; text-align:center; background-color:#f2f2f2; font-family:Times New Roman,Times,serif; font-size:8pt; font-weight:bold; vertical-align:middle; line-height:1.2;';
      return `
        <div style="font-size:12pt; font-weight:bold; margin-bottom:6px; text-align:center; font-family:'Times New Roman',Times,serif;">
          II. O'quv-uslubiy ishlar
        </div>
        <table class="table-manual" style="width:100%; border-collapse:collapse;">
          <thead>
            <tr>
              <th style="${th} width:5%;">№</th>
              <th style="${th} width:45%;">Ish turlari</th>
              <th style="${th} width:15%;">Bajarish muddati</th>
              <th style="${th} width:25%;">Ish turlarini amalga oshirish mexanizmi</th>
              <th style="${th} width:10%;">To'plagan reyting bali</th>
            </tr>
          </thead>
          <tbody>
            ${this.buildDocManualRowsHtml(this.oquvUslubiyRows)}
          </tbody>
        </table>
      `;
    },

    buildDocSectionIIIHtml(isWord = false) {
      const th = 'border:1px solid #000; padding:3px 4px 6px 4px; text-align:center; background-color:#f2f2f2; font-family:Times New Roman,Times,serif; font-size:8pt; font-weight:bold; vertical-align:middle; line-height:1.2;';
      return `
        <div style="font-size:12pt; font-weight:bold; margin-bottom:6px; text-align:center; font-family:'Times New Roman',Times,serif;">
          III. Ilmiy-tadqiqot ishlari
        </div>
        <table class="table-manual" style="width:100%; border-collapse:collapse;">
          <thead>
            <tr>
              <th style="${th} width:5%;">№</th>
              <th style="${th} width:45%;">Ish turlari</th>
              <th style="${th} width:15%;">Bajarish muddati</th>
              <th style="${th} width:25%;">Ish turlarini amalga oshirish mexanizmi</th>
              <th style="${th} width:10%;">To'plagan reyting bali</th>
            </tr>
          </thead>
          <tbody>
            ${this.buildDocManualRowsHtml(this.ilmiyTadqiqotRows)}
          </tbody>
        </table>
      `;
    },

    buildDocSectionIVUstozHtml(isWord = false) {
      const th = 'border:1px solid #000; padding:3px 4px 6px 4px; text-align:center; background-color:#f2f2f2; font-family:Times New Roman,Times,serif; font-size:8pt; font-weight:bold; vertical-align:middle; line-height:1.2;';
      return `
        <div style="font-size:12pt; font-weight:bold; margin-bottom:6px; text-align:center; font-family:'Times New Roman',Times,serif;">
          IV. "Ustoz-shogird" ishlari
        </div>
        <table class="table-manual" style="width:100%; border-collapse:collapse;">
          <thead>
            <tr>
              <th style="${th} width:5%;">№</th>
              <th style="${th} width:45%;">Ish turlari</th>
              <th style="${th} width:15%;">Bajarish muddati</th>
              <th style="${th} width:25%;">Ish turlarini amalga oshirish mexanizmi</th>
              <th style="${th} width:10%;">To'plagan reyting bali</th>
            </tr>
          </thead>
          <tbody>
            ${this.buildDocManualRowsHtml(this.ustozShogirdRows)}
          </tbody>
        </table>
      `;
    },

    buildDocSectionIVFinalHtml(isWord = false) {
      const kafedraDecisionText = getKafedraDecisionText(this.kafedraName);
      const gt = this.grandTotals || {};
      const getSum = (rows) => (rows || []).reduce((sum, r) => sum + (Number(r.reyting) || 0), 0);
      const oquvRating = getSum(this.oquvUslubiyRows);
      const ilmiyRating = getSum(this.ilmiyTadqiqotRows);
      const ustozRating = getSum(this.ustozShogirdRows);
      const grandTotalSum = (gt.jami || 0) + oquvRating + ilmiyRating + ustozRating;

      const diagonalHeaderCell = isWord
        ? `<th style="border:1px solid #000; width:22%; padding:3px 4px 6px 4px; background-color:#f2f2f2; vertical-align:middle; mso-border-diagonal-down:1.0pt solid windowtext;">
            <div style="text-align:right; font-size:8pt; font-weight:bold; line-height:1; font-family:'Times New Roman',Times,serif;">Faoliyat turi</div>
            <div style="margin-top:8px; text-align:left; font-size:8pt; font-weight:bold; line-height:1; font-family:'Times New Roman',Times,serif;">Reyting ballari</div>
          </th>`
        : `<th style="border:1px solid #000; width:22%; padding:0; height:42px; background-color:#f2f2f2; vertical-align:middle; position:relative;">
            <div style="position:relative; width:100%; height:42px; box-sizing:border-box;">
              <svg style="position:absolute; top:0; left:0; width:100%; height:100%; display:block;" preserveAspectRatio="none" viewBox="0 0 100 100">
                <line x1="0" y1="0" x2="100" y2="100" stroke="#000000" stroke-width="1.2"/>
              </svg>
              <div style="position:absolute; top:4px; right:6px; font-size:8pt; font-weight:bold; text-align:right; line-height:1; font-family:'Times New Roman',Times,serif;">Faoliyat turi</div>
              <div style="position:absolute; bottom:8px; left:6px; font-size:8pt; font-weight:bold; text-align:left; line-height:1; font-family:'Times New Roman',Times,serif;">Reyting ballari</div>
            </div>
          </th>`;

      return `
        <div style="font-size: 11pt; font-weight: bold; margin-bottom: 6px; text-align: center; font-family:'Times New Roman',Times,serif;">
          O'qituvchi o'quv yili davomida to'plagan reyting ballari
        </div>
        <table class="table-manual table-rating" style="width: 100%; border-collapse: collapse; font-size: 8pt; margin-bottom: 14px; font-family:'Times New Roman',Times,serif;">
          <thead>
            <tr style="background-color: #f2f2f2; font-weight: bold; page-break-inside: avoid; page-break-after: avoid;">
              ${diagonalHeaderCell}
              <th style="border: 1px solid #000; padding: 3px 4px 6.5px 4px; width: 15.6%; text-align: center; vertical-align: middle;">O'quv ishlari</th>
              <th style="border: 1px solid #000; padding: 3px 4px 6.5px 4px; width: 15.6%; text-align: center; vertical-align: middle;">O'quv-uslubiy ishlar</th>
              <th style="border: 1px solid #000; padding: 3px 4px 6.5px 4px; width: 15.6%; text-align: center; vertical-align: middle;">Ilmiy-tadqiqot ishlari</th>
              <th style="border: 1px solid #000; padding: 3px 4px 6.5px 4px; width: 15.6%; text-align: center; vertical-align: middle;">"Ustoz-shogird" ishlari</th>
              <th style="border: 1px solid #000; padding: 3px 4px 6.5px 4px; width: 15.6%; text-align: center; vertical-align: middle;">Jami</th>
            </tr>
          </thead>
          <tbody>
            <tr style="page-break-inside: avoid;">
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; font-weight: bold; vertical-align: middle;">Reja</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${gt.jami || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${oquvRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${ilmiyRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${ustozRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; font-weight: bold; vertical-align: middle;">${grandTotalSum}</td>
            </tr>
            <tr style="page-break-inside: avoid;">
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; font-weight: bold; vertical-align: middle;">Amalda</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; font-weight: bold; vertical-align: middle;">&nbsp;</td>
            </tr>
            <tr style="page-break-inside: avoid;">
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; font-weight: bold; vertical-align: middle;">Qo'shimcha</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
            </tr>
            <tr style="page-break-inside: avoid;">
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; font-weight: bold; vertical-align: middle;">Jarima</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">&nbsp;</td>
            </tr>
            <tr style="background-color: #f2f2f2; font-weight: bold; page-break-inside: avoid;">
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; vertical-align: middle;">Jami</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${gt.jami || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${oquvRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${ilmiyRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${ustozRating || 0}</td>
              <td style="border: 1px solid #000; padding: 2.5px 6px 7px 6px; text-align: center; vertical-align: middle;">${grandTotalSum}</td>
            </tr>
          </tbody>
        </table>

        <div style="font-size: 9.5pt; line-height: 1.6; margin-top: 14px; margin-bottom: 18px; font-family:'Times New Roman',Times,serif;">
          <div style="margin-bottom: 10px;">
            <b>Kafedra yig'ilishi qarori:</b> ${kafedraDecisionText ? `<span style="text-decoration: underline;">${kafedraDecisionText}</span>` : `____________________________________________________________________________________<br/>_______________________________________________________________________________________________________________`}
          </div>
          <div>
            <b>Fakultet Kengashi qarori:</b> ____________________________________________________________________________________<br/>
            _______________________________________________________________________________________________________________
          </div>
        </div>

        <table data-layout="true" style="width: 100%; border-collapse: collapse; border: none; margin-top: 20px; font-size: 9.5pt; font-family:'Times New Roman',Times,serif;">
          <tr>
            <td style="width: 31%; border: none; padding: 0; text-align: left; vertical-align: top;">
              <b>Professor-o'qituvchi</b><br/><br/>
              _______________________
            </td>
            <td style="width: 3.5%; border: none;">&nbsp;</td>
            <td style="width: 31%; border: none; padding: 0; text-align: left; vertical-align: top;">
              <b>Kafedra mudiri</b><br/><br/>
              _______________________
            </td>
            <td style="width: 3.5%; border: none;">&nbsp;</td>
            <td style="width: 31%; border: none; padding: 0; text-align: left; vertical-align: top;">
              <b>Fakultet dekani</b><br/><br/>
              _______________________
            </td>
          </tr>
        </table>
      `;
    },

    buildDocSectionIVHtml(isWord = false) {
      if (this.ustozShogirdRows && this.ustozShogirdRows.length > 3) {
        return this.buildDocSectionIVUstozHtml(isWord) +
          (isWord ? '<br clear="all" style="page-break-before: always; mso-break-type: page-break;" />' : '') +
          this.buildDocSectionIVFinalHtml(isWord);
      }
      return this.buildDocSectionIVUstozHtml(isWord) + '<div style="margin-top:10px;"></div>' + this.buildDocSectionIVFinalHtml(isWord);
    },

    generateDocumentHtml(mode = 'word') {
      const coverHtml = this.buildDocCoverContent(true);
      const tableIStructure = this.buildDocTableIStructure(true);
      const sectionIIHtml = this.buildDocSectionIIHtml(true);
      const sectionIIIHtml = this.buildDocSectionIIIHtml(true);
      const sectionIVHtml = this.buildDocSectionIVHtml(true);

      const wordPageBreak = '<br clear="all" style="page-break-before: always; mso-break-type: page-break;" />';

      const tableIPagesHtml = tableIStructure.pages.map((p, idx) => `
        ${idx > 0 ? wordPageBreak : ''}
        <div>
          <div style="font-size: 12pt; font-weight: bold; margin-bottom: 2px; text-align: center;">
            ${p.title}
          </div>
          <div style="font-size: 9pt; font-style: italic; margin-bottom: 5px; text-align: center;">
            ${p.subtitle}
          </div>
          <table class="table-compact" style="width: 100%; border-collapse: collapse;">
            ${p.theadHtml}
            <tbody>
              ${p.rowsHtml}
            </tbody>
          </table>
        </div>
      `).join('');

      return `<html xmlns:v="urn:schemas-microsoft-com:vml"
            xmlns:o="urn:schemas-microsoft-com:office:office"
            xmlns:w="urn:schemas-microsoft-com:office:word"
            xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8">
        <!--[if gte mso 9]><xml>
          <w:WordDocument>
            <w:View>Print</w:View>
            <w:Zoom>100</w:Zoom>
            <w:DoNotOptimizeForBrowser/>
          </w:WordDocument>
        </xml><![endif]-->
        <style>
          /* MS Word universal paragraph & element reset */
          p.MsoNormal, li.MsoNormal, div.MsoNormal, p, div, span, td, th {
            margin: 0cm;
            margin-top: 0pt;
            margin-bottom: 0.0001pt;
            padding: 0cm;
            font-family: 'Times New Roman', serif;
          }
          table {
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            mso-padding-alt: 0pt 2pt 0pt 2pt;
          }
          th, td {
            border: 1px solid #000000;
            vertical-align: middle;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
            text-align: center;
          }
          thead {
            display: table-header-group;
          }
          tr {
            page-break-inside: avoid;
            mso-yfti-midrow: yes;
          }
          thead tr {
            page-break-inside: avoid;
            page-break-after: avoid;
            mso-yfti-firstrow: yes;
          }

          /* Butun hujjat uchun Knijnaya (Portrait) formati */
          @page WordSection1 {
            size: 21.0cm 29.7cm;
            margin: 1.0cm 1.2cm 1.0cm 1.2cm;
            mso-page-orientation: portrait;
            mso-header-margin: 30pt;
            mso-footer-margin: 30pt;
            mso-paper-source: 0;
            mso-footer: f1;
          }
          div.WordSection1 {
            page: WordSection1;
          }

          body {
            font-family: 'Times New Roman', Times, serif;
            font-size: 11pt;
            line-height: 1.15;
            color: #000000;
          }

          .table-compact {
            width: 100%;
            border-collapse: collapse;
          }
          .table-compact th, .table-compact td {
            padding: 2pt 2pt 4pt 2pt;
            font-size: 7.5pt;
            line-height: 1.15;
            word-wrap: break-word;
          }

          .table-manual {
            width: 100%;
            border-collapse: collapse;
          }
          .table-manual th, .table-manual td {
            padding: 2.5pt 3.5pt 4.5pt 3.5pt;
            font-size: 8.5pt;
            line-height: 1.2;
            word-wrap: break-word;
          }
        </style>
      </head>
      <body>

        <!-- Footer page number definitions -->
        <div style="mso-element:footer; id:f1;">
          <p class="MsoFooter" style="text-align: center; font-family:'Times New Roman'; font-size:10pt;">
            <!--[if supportFields]><span style='mso-element:field-begin'></span>PAGE<span style='mso-element:field-separator'></span><![endif]-->
            <span style='mso-no-proof:yes'></span>
            <!--[if supportFields]><span style='mso-element:field-end'></span><![endif]-->
          </p>
        </div>

        <div class="WordSection1">
          <!-- ════════════════════ MUQOVA SAHIFASI (KNIJNAYA) ════════════════════ -->
          <div>
            ${coverHtml}
          </div>

          ${wordPageBreak}

          <!-- ════════════════════ I. O'QUV ISHLARI (KNIJNAYA) ════════════════════ -->
          <div>
            ${tableIPagesHtml}
          </div>

          ${wordPageBreak}

          <!-- ════════════════════ II. O'QUV-USLUBIY ISHLAR (KNIJNAYA) ════════════════════ -->
          <div>
            ${sectionIIHtml}
          </div>

          ${wordPageBreak}

          <!-- ════════════════════ III. ILMIY-TADQIQOT ISHLARI (KNIJNAYA) ════════════════════ -->
          <div>
            ${sectionIIIHtml}
          </div>

          ${wordPageBreak}

          <!-- ════════════════════ IV. USTOZ-SHOGIRD + REYTING + QARORLAR + IMZOLAR (KNIJNAYA) ════════════════════ -->
          <div>
            ${sectionIVHtml}
          </div>
        </div>

      </body>
      </html>`;
    },

    async exportToWord() {
      const oquvYili = "2026-2027";
      const name = this.teacherName || "O'qituvchi";
      await this.generateProrektorQr();
      const htmlBody = this.generateDocumentHtml('word');

      let fileData = "";
      if (this.prorektorQrCodeUrl && this.prorektorQrCodeUrl.startsWith("data:image/png;base64,")) {
        const rawBase64 = this.prorektorQrCodeUrl.replace(/^data:image\/png;base64,/, "");
        const formattedBase64 = (rawBase64.match(/.{1,76}/g) || [rawBase64]).join('\r\n');
        const boundary = "----=_NextPart_MSWord_Doc_Boundary_789";

        fileData = [
          `MIME-Version: 1.0`,
          `Content-Type: multipart/related; type="text/html"; boundary="${boundary}"`,
          ``,
          `This is a multi-part message in MIME format.`,
          ``,
          `--${boundary}`,
          `Content-Type: text/html; charset="utf-8"`,
          `Content-Transfer-Encoding: 8bit`,
          `Content-Location: document.htm`,
          ``,
          htmlBody,
          ``,
          `--${boundary}`,
          `Content-Type: image/png; name="prorektor_qr.png"`,
          `Content-Transfer-Encoding: base64`,
          `Content-ID: <prorektor_qr.png>`,
          `Content-Location: prorektor_qr.png`,
          ``,
          formattedBase64,
          ``,
          `--${boundary}--`
        ].join('\r\n');
      } else {
        fileData = "\ufeff" + htmlBody;
      }

      const blob = new Blob([fileData], { type: "application/msword;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `shaxsiy_reja_${name.replace(/\s+/g, "_")}_${oquvYili}.doc`;
      a.click();
      URL.revokeObjectURL(url);
    },

    async exportToPdf() {
      const oquvYili = "2026-2027";
      const name = this.teacherName || "O'qituvchi";
      const fileName = `shaxsiy_reja_${name.replace(/\s+/g, '_')}_${oquvYili}.pdf`;

      await this.generateProrektorQr();

      this.isExportingPdf = true;
      this.pdfExportProgress = "Hujjat sahifalari tayyorlanmoqda...";

      const staging = document.createElement('div');
      staging.id = 'shaxsiy-reja-pdf-staging';
      staging.style.position = 'fixed';
      staging.style.left = '0';
      staging.style.top = '0';
      staging.style.zIndex = '999990';
      staging.style.backgroundColor = '#ffffff';
      staging.style.pointerEvents = 'none';
      staging.style.opacity = '1';
      document.body.appendChild(staging);

      // ═══════ CSS matching Word document visual style exactly ═══════
      const wordMatchCss = `
        <style>
          #shaxsiy-reja-pdf-staging * {
            box-sizing: border-box !important;
            font-family: 'Times New Roman', Times, serif !important;
            color: #000000 !important;
            -webkit-font-smoothing: antialiased;
            text-rendering: geometricPrecision;
          }
          #shaxsiy-reja-pdf-staging {
            background: #ffffff;
          }
          #shaxsiy-reja-pdf-staging table {
            border-collapse: separate !important;
            border-spacing: 0 !important;
            width: 100% !important;
            border-top: 1px solid #000000 !important;
            border-left: 1px solid #000000 !important;
            background-color: #ffffff !important;
          }
          /* Table cells: solid borders, text wraps inside */
          #shaxsiy-reja-pdf-staging th,
          #shaxsiy-reja-pdf-staging td {
            border: none !important;
            border-right: 1px solid #000000 !important;
            border-bottom: 1px solid #000000 !important;
            vertical-align: middle !important;
            word-wrap: break-word !important;
            white-space: normal !important;
            box-sizing: border-box !important;
          }
          #shaxsiy-reja-pdf-staging th {
            background-color: #f2f2f2 !important;
            font-weight: bold !important;
            text-align: center !important;
          }
          /* Table I (portrait / knijnaya) */
          #shaxsiy-reja-pdf-staging .table-compact th {
            padding: 2.5px 2px 5.5px 2px !important;
            font-size: 7.5pt !important;
            line-height: 1.15 !important;
            vertical-align: middle !important;
          }
          #shaxsiy-reja-pdf-staging .table-compact td {
            padding: 2px 2.5px 6px 2.5px !important;
            font-size: 8pt !important;
            line-height: 1.2 !important;
            vertical-align: middle !important;
          }
          /* Tables II, III, IV manual style — match Word */
          #shaxsiy-reja-pdf-staging .table-manual th {
            padding: 3px 4px 6.5px 4px !important;
            font-size: 8.5pt !important;
            line-height: 1.2 !important;
            vertical-align: middle !important;
          }
          #shaxsiy-reja-pdf-staging .table-manual td {
            padding: 2.5px 5px 6.5px 5px !important;
            font-size: 8.5pt !important;
            line-height: 1.25 !important;
            vertical-align: middle !important;
          }
          /* Rating table in Section IV */
          #shaxsiy-reja-pdf-staging .table-rating th {
            padding: 3px 4px 6.5px 4px !important;
            font-size: 8.5pt !important;
            line-height: 1.2 !important;
            vertical-align: middle !important;
          }
          #shaxsiy-reja-pdf-staging .table-rating td {
            padding: 3px 6px 7.5px 6px !important;
            font-size: 8.5pt !important;
            line-height: 1.25 !important;
            vertical-align: middle !important;
          }
          /* Cover page and signature layout tables — completely borderless */
          #shaxsiy-reja-pdf-staging table[data-layout] {
            border: none !important;
          }
          #shaxsiy-reja-pdf-staging [data-layout] td,
          #shaxsiy-reja-pdf-staging [data-layout] th {
            border: none !important;
            background-color: #ffffff !important;
          }
        </style>
      `;
      // Helper: render HTML content as canvas for given page size
      const renderPage = async (htmlContent, hasWatermark = false) => {
        const w = 794;
        const h = 1122;
        const padding = '18px 14px';
        const baseFontSize = '10pt';
        const watermarkHtml = hasWatermark ? `
          <div style="position:absolute; top:0; left:0; width:100%; height:100%; display:flex; align-items:center; justify-content:center; pointer-events:none; z-index:9999; overflow:hidden;">
            <div style="font-family:'Times New Roman',Times,serif; font-size:62pt; font-weight:bold; color:#000000; opacity:0.13; transform:rotate(-30deg); transform-origin:center center; text-transform:uppercase; letter-spacing:10px; white-space:nowrap; user-select:none; line-height:1;">
              TASDIQLANDI
            </div>
          </div>
        ` : '';
        staging.innerHTML = `
          ${wordMatchCss}
          <div id="pdf-render-target" style="position:relative; width:${w}px; min-height:${h}px; padding:${padding}; box-sizing:border-box; background:#ffffff; font-family:'Times New Roman',Times,serif; font-size:${baseFontSize}; color:#000000; line-height:1.3;">
            ${watermarkHtml}
            ${htmlContent}
          </div>
        `;
        await this.$nextTick();
        await new Promise(r => setTimeout(r, 80));
        const el = document.getElementById('pdf-render-target');
        return await html2canvas(el, {
          scale: 2.2,
          useCORS: true,
          backgroundColor: '#ffffff',
          logging: false,
          windowWidth: w,
          width: w,
          scrollX: 0,
          scrollY: 0,
          allowTaint: true,
        });
      };

      try {
        const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4', compress: true });
        let pageCount = 0;
        const isApproved = this.planStatus?.oquv === 'approved';

        const addCanvas = (canvas) => {
          if (pageCount > 0) doc.addPage('a4', 'p');
          const pageW = 210;
          const pageH = 297;
          const scale = Math.min(pageW / canvas.width, pageH / canvas.height);
          const imgW = canvas.width * scale;
          const imgH = canvas.height * scale;
          const posX = (pageW - imgW) / 2;
          const posY = (pageH - imgH) / 2;
          doc.addImage(canvas.toDataURL('image/png'), 'PNG', posX, posY, imgW, imgH, undefined, 'FAST');
          pageCount++;
        };

        // ══════ 1. COVER PAGE (PORTRAIT) ══════
        this.pdfExportProgress = "Muqova sahifasi tayyorlanmoqda...";
        addCanvas(await renderPage(this.buildDocCoverContent(false), false));

        // ══════ 2. TABLE I: O'QUV ISHLARI (PORTRAIT) ══════
        const tableIStructure = this.buildDocTableIStructure(false);
        for (let pIdx = 0; pIdx < tableIStructure.pages.length; pIdx++) {
          const pageData = tableIStructure.pages[pIdx];
          this.pdfExportProgress = `O'quv ishlari jadvali (${pIdx + 1}/${tableIStructure.pages.length}) tayyorlanmoqda...`;
          const tablePageHtml = `
            <div style="font-size:13pt; font-weight:bold; margin-bottom:4px; text-align:center; font-family:'Times New Roman',Times,serif;">${pageData.title}</div>
            <div style="font-size:9.5pt; font-style:italic; margin-bottom:8px; text-align:center; font-family:'Times New Roman',Times,serif;">${pageData.subtitle}</div>
            <table class="table-compact" style="width:100%; border-collapse:collapse;">
              ${pageData.theadHtml}
              <tbody>${pageData.rowsHtml}</tbody>
            </table>
          `;
          addCanvas(await renderPage(tablePageHtml, isApproved));
        }

        // ══════ 3. TABLE II: O'QUV-USLUBIY ISHLAR (PORTRAIT) ══════
        this.pdfExportProgress = "O'quv-uslubiy ishlar jadvali tayyorlanmoqda...";
        addCanvas(await renderPage(this.buildDocSectionIIHtml(false), isApproved));

        // ══════ 4. TABLE III: ILMIY-TADQIQOT ISHLARI (PORTRAIT) ══════
        this.pdfExportProgress = "Ilmiy-tadqiqot ishlari jadvali tayyorlanmoqda...";
        addCanvas(await renderPage(this.buildDocSectionIIIHtml(false), isApproved));

        // ══════ 5. TABLE IV: USTOZ-SHOGIRD (PORTRAIT) ══════
        this.pdfExportProgress = "Ustoz-shogird jadvali tayyorlanmoqda...";
        addCanvas(await renderPage(this.buildDocSectionIVUstozHtml(false), isApproved));

        // ══════ 6. YAKUNIY SAHIFA: REYTING + QARORLAR + IMZOLAR (PORTRAIT) ══════
        this.pdfExportProgress = "Yakuniy xulosalar va imzolar tayyorlanmoqda...";
        addCanvas(await renderPage(this.buildDocSectionIVFinalHtml(false), isApproved));

        // ══════ SAVE PDF ══════
        this.pdfExportProgress = "PDF fayl yuklanmoqda...";
        doc.save(fileName);
      } catch (err) {
        console.error('PDF yuklash xatosi:', err);
        alert('PDF yuklab olishda xatolik yuz berdi: ' + (err.message || err));
      } finally {
        if (staging.parentNode) staging.parentNode.removeChild(staging);
        this.isExportingPdf = false;
        this.pdfExportProgress = "";
      }
    }
  }
};
</script>

<style scoped>
@keyframes pdfSpin {
  to { transform: rotate(360deg); }
}

/* Manual section styles */
.cell-input {
  width: 100%;
  border: none;
  background: transparent;
  font-size: 13px;
  font-family: inherit;
  color: #1e293b;
  resize: vertical;
  outline: none;
  padding: 4px 6px;
  line-height: 1.5;
}
.cell-input:focus {
  background: #f0f7ff;
  border-radius: 4px;
}
.cell-input[readonly] {
  color: #334155;
  cursor: default;
}
.cell-input.rating-active:not([readonly]) {
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
}
.cell-input.rating-active:not([readonly]):focus {
  border-color: #0284c7;
  background: #f0f9ff;
  box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.18);
}
.manual-actions {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
}
.manual-save-bar {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
}
.btn-add {
  background: #7c3aed;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-add:hover { background: #6d28d9; }
.btn-remove {
  background: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-remove:hover { background: #b91c1c; }
.btn-save {
  background: #16a34a;
  color: white;
  border: none;
  padding: 9px 22px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s;
}
.btn-save:hover { background: #15803d; }
.btn-save:disabled { background: #86efac; cursor: not-allowed; }


.page-wrapper {
  background-color: #f8fafc;
  min-height: calc(100vh - 64px);
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 20px;
}

.page-container {
  max-width: 98%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.page-header {
  margin-bottom: 4px;
}

.breadcrumb {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crumb-link {
  color: #3b82f6;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.15s ease;
}

.crumb-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.separator {
  color: #cbd5e1;
}

.crumb-current {
  color: #0f172a;
  font-weight: 600;
}

/* Profiles Card */
.info-card, .stepper-card, .table-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.card-title-bar {
  background: #f8fafc;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.card-title-bar h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.profile-table {
  width: 100%;
  border-collapse: collapse;
}

.profile-table td {
  padding: 14px 24px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 15px;
}

.profile-table tr:last-child td {
  border-bottom: none;
}

.label-cell {
  width: 250px;
  color: #64748b;
  font-weight: 500;
  background-color: #fcfcfc;
}

.value-cell {
  color: #0f172a;
  font-weight: 600;
}

/* Stepper Approval Tracker */
.stepper-card {
  padding: 24px;
}

.stepper-track {
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;
  gap: 16px;
}

.stepper-node {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 160px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.node-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.node-label {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  cursor: default;
}

.node-label.clickable-label {
  cursor: pointer;
  transition: color 0.15s;
}

.node-label.clickable-label:hover {
  color: #2563eb;
}

.node-subtitle {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  margin-top: 2px;
}

/* Stepper Node States */
.node-approved {
  border-color: #bbf7d0;
  background-color: #f0fdf4;
}
.node-approved .node-icon {
  background-color: #16a34a;
}

.node-waiting {
  border-color: #fde68a;
  background-color: #fffbeb;
}
.node-waiting .node-icon {
  background-color: #d97706;
}

.node-rejected {
  border-color: #fecaca;
  background-color: #fef2f2;
}
.node-rejected .node-icon {
  background-color: #dc2626;
}

/* Detailed Table styling */
.table-container {
  overflow-x: auto;
}

.reja-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #334155;
}

.reja-table th, .reja-table td {
  border: 1px solid #e2e8f0;
  padding: 12px 10px;
  vertical-align: middle;
}

.reja-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  text-align: center;
}

.th-group {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
}

.th-audit {
  background-color: #fffdf0;
  color: #854d0e;
}

.th-tashqari {
  background-color: #eff6ff;
  color: #1e40af;
}

.th-audit-sub {
  background-color: #fffbeb;
  font-size: 12px;
}

.th-tashqari-sub {
  background-color: #f0f7ff;
  font-size: 12px;
}

.semester-divider-row {
  background-color: #f1f5f9;
}

.semester-header {
  font-weight: 700;
  font-size: 14px;
  color: #1e293b;
  padding: 8px 16px;
  text-align: left;
}

.totals-row td {
  font-size: 13px;
  border-top: 2px solid #cbd5e1;
}

.grand-totals-row td {
  font-size: 14px;
  border-top: 2px solid #94a3b8;
  border-bottom: 2px double #64748b;
}

/* Export Button */
.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #10b981;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.export-btn:hover {
  background-color: #059669;
}

.export-btn-word {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.export-btn-word:hover {
  background-color: #1d4ed8;
}

.export-btn-pdf {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.export-btn-pdf:hover {
  background-color: #b91c1c;
}

/* Modal Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.approval-modal {
  background: white;
  width: 440px;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.modal-header {
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #94a3b8;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.status-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status-opt-btn {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: white;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}

.status-opt-btn.approved {
  background: #16a34a;
  color: white;
  border-color: #16a34a;
}
.status-opt-btn.approved:hover {
  background: #15803d;
}

.status-opt-btn.waiting {
  background: #d97706;
  color: white;
  border-color: #d97706;
}
.status-opt-btn.waiting:hover {
  background: #b45309;
}

.status-opt-btn.rejected {
  background: #dc2626;
  color: white;
  border-color: #dc2626;
}
.status-opt-btn.rejected:hover {
  background: #b91c1c;
}

.btn-delete-item {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fca5a5;
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.btn-delete-item:hover {
  background: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
  transform: scale(1.05);
}

.btn-edit-teacher {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #2563eb;
  color: #ffffff;
  border: none;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-edit-teacher:hover {
  background: #1d4ed8;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
}

.edit-teacher-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 640px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-group label {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.form-input-text {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 13px;
  color: #1e293b;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.form-input-text:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.btn-stavka-quick {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-stavka-quick:hover {
  background: #2563eb;
  color: #ffffff;
  border-color: #2563eb;
}

/* Prorektor QR Banner Styles */
.prorektor-qr-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border: 1.5px solid #86efac;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.08);
}

.qr-banner-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qr-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #15803d;
  color: #ffffff;
  padding: 3px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  width: fit-content;
}

.qr-title-block .qr-main-title {
  font-size: 15px;
  font-weight: 700;
  color: #14532d;
}

.qr-title-block .qr-signatory {
  font-size: 13px;
  color: #166534;
  margin-top: 1px;
}

.qr-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.qr-status-tag {
  background: #22c55e;
  color: #ffffff;
  font-weight: 800;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  letter-spacing: 0.02em;
}

.qr-date-tag, .qr-doc-tag {
  font-size: 12px;
  color: #166534;
  font-weight: 600;
}

.qr-banner-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 6px;
  background: #ffffff;
  border: 1.5px solid #bbf7d0;
  border-radius: 10px;
  transition: transform 0.15s, box-shadow 0.15s;
}

.qr-banner-right:hover {
  transform: scale(1.04);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.18);
}

.qr-preview-img {
  width: 70px;
  height: 70px;
  display: block;
}

.qr-zoom-label {
  font-size: 10px;
  font-weight: 600;
  color: #15803d;
  margin-top: 3px;
}

.qr-modal-card {
  max-width: 440px !important;
}
</style>
